// Doa & Dzikir Data
// Static data for MVP, can be migrated to database later

export const DOA_CATEGORIES = [
  { id: "quran-prophet", name: "Al-Quran & Nabi", englishName: "Quran & Prophet", icon: "star", premium: false },
  { id: "morning", name: "Pagi", englishName: "Morning", icon: "sunrise", premium: false },
  { id: "evening", name: "Sore", englishName: "Evening", icon: "sunset", premium: false },
  { id: "prayer", name: "Sholat", englishName: "Prayer", icon: "mosque", premium: false },
  { id: "daily", name: "Harian", englishName: "Daily", icon: "calendar", premium: false },
  { id: "travel", name: "Bepergian", englishName: "Travel", icon: "plane", premium: true },
  { id: "sickness", name: "Sakit", englishName: "Sickness", icon: "heart-pulse", premium: true },
  { id: "protection", name: "Perlindungan", englishName: "Protection", icon: "shield", premium: true },
];

export const DUAS = [
  // Morning Dzikir
  {
    id: "morning-1",
    category: "morning",
    title: "Doa Bangun Tidur",
    titleEn: "Waking Up",
    arabic: "اَلْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
    transliteration: "Alhamdulillahilladzii ahyaanaa ba'da maa amaatanaa wa ilaihin nusyuur",
    indonesian: "Segala puji bagi Allah yang telah menghidupkan kami setelah mematikan kami dan kepada-Nya kami akan dikembalikan.",
    english: "All praise is for Allah who gave us life after having taken it from us and unto Him is the resurrection.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "morning-2",
    category: "morning",
    title: "Sayyidul Istighfar",
    titleEn: "Master of Seeking Forgiveness",
    arabic: "اللَّهُمَّ أَنْتَ رَبِّي لَا إِلَهَ إِلَّا أَنْتَ خَلَقْتَنِي وَأَنَا عَبْدُكَ وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ أَعُوذُ بِكَ مِنْ شَرِّ مَا صَنَعْتُ أَبُوءُ لَكَ بِنِعْمَتِكَ عَلَيَّ وَأَبُوءُ بِذَنْبِي فَاغْفِرْ لِي فَإِنَّهُ لَا يَغْفِرُ الذُّنُوبَ إِلَّا أَنْتَ",
    transliteration: "Allahumma anta rabbi la ilaha illa anta, khalaqtani wa ana 'abduka, wa ana 'ala 'ahdika wa wa'dika mastatha'tu, a'udzu bika min syarri ma shana'tu, abu-u laka bini'matika 'alayya, wa abu-u bidzanbi, faghfirli fainnahu la yaghfirudz dzunuba illa anta",
    indonesian: "Ya Allah, Engkau adalah Tuhanku, tidak ada Tuhan yang berhak disembah kecuali Engkau. Engkau telah menciptakan aku dan aku adalah hamba-Mu. Aku akan setia pada perjanjianku dan janji-Mu sesuai kemampuanku. Aku berlindung kepada-Mu dari kejahatan yang kuperbuat. Aku mengakui nikmat-Mu kepadaku dan aku mengakui dosaku, maka ampunilah aku. Sesungguhnya tidak ada yang dapat mengampuni dosa kecuali Engkau.",
    english: "O Allah, You are my Lord. There is no god but You. You created me and I am Your servant. I uphold Your covenant and promise as best I can. I seek refuge in You from the evil I have done. I acknowledge Your blessings upon me and I acknowledge my sins, so forgive me. Indeed, none forgives sins except You.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "morning-3",
    category: "morning",
    title: "Dzikir Pagi - Subhanallah",
    titleEn: "Morning - SubhanAllah",
    arabic: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ",
    transliteration: "Subhanallahi wa bihamdihi",
    indonesian: "Maha Suci Allah dan segala puji bagi-Nya.",
    english: "Glory is to Allah and praise is to Him.",
    reference: "HR. Muslim",
    repeat: 100,
  },
  {
    id: "morning-4",
    category: "morning",
    title: "Memohon Perlindungan dari Kekufuran",
    titleEn: "Seeking Refuge from Disbelief",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ أَنْ أُشْرِكَ بِكَ شَيْئًا أَعْلَمُهُ وَأَسْتَغْفِرُكَ لِمَا لَا أَعْلَمُهُ",
    transliteration: "Allahumma inni a'udzu bika an usyrika bika syai'an a'lamuhu wa astaghfiruka lima la a'lamuhu",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari mempersekutukan-Mu dengan sesuatu yang aku ketahui, dan aku memohon ampunan kepada-Mu dari apa yang tidak aku ketahui.",
    english: "O Allah, I seek refuge in You from associating anything with You knowingly, and I seek Your forgiveness for what I do unknowingly.",
    reference: "HR. Ahmad",
    repeat: 3,
  },
  {
    id: "morning-5",
    category: "morning",
    title: "Agar Terhindar dari Musibah",
    titleEn: "Protection from Calamities",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ عَذَابِ جَهَنَّمَ وَمِنْ عَذَابِ الْقَبْرِ وَمِنْ فِتْنَةِ الْمَحْيَا وَالْمَمَاتِ وَمِنْ فِتْنَةِ الْمَسِيحِ الدَّجَّالِ",
    transliteration: "Allahumma inni a'udzu bika min 'adhabi jahannama wa min 'adhabil qabri wa min fitnatil mahya wal mamati wa min fitnatil masihid dajjal",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari siksa neraka jahanam, siksa kubur, fitnah kehidupan dan kematian, serta fitnah Dajjal.",
    english: "O Allah, I seek refuge in You from the punishment of Hellfire, the punishment of the grave, the trials of life and death, and the trials of the False Messiah.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "morning-6",
    category: "morning",
    title: "Memohon Ridho Allah",
    titleEn: "Seeking Allah's Pleasure",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الرِّضَى بَعْدَ الْقَضَاءِ وَأَسْأَلُكَ عَيْشًا رَاضِيًا وَأَسْأَلُكَ نَعِيمًا لَا يَبِيدُ وَأَسْأَلُكَ الْفَرَحَةَ الدَّائِمَةَ",
    transliteration: "Allahumma inni as'aluka ridha ba'dal qadha'i wa as'aluka 'aisyan radiyyan wa as'aluka na'iiman la yabidu wa as'aluka farhada da'imah",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu kerelaan setelah ketetapan, dan aku memohon kehidupan yang diridhoi, dan nikmat yang tidak kekal, dan kebahagiaan yang abadi.",
    english: "O Allah, I ask You for contentment after Your decree, for a pleasing life, for everlasting bliss, and for continuous joy.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "morning-7",
    category: "morning",
    title: "Menyerahkan Segala Urusan kepada Allah",
    titleEn: "Entrusting All Affairs to Allah",
    arabic: "اللَّهُمَّ بِكَ أَصْبَحْنَا وَبِكَ أَمْسَيْنَا وَبِكَ نَحْيَا وَبِكَ نَمُوتُ وَإِلَيْكَ النُّشُورُ",
    transliteration: "Allahumma bika asbahna wa bika amsaina wa bika nahya wa bika namutu wa ilaikan nusyur",
    indonesian: "Ya Allah, dengan nikmat-Mu kami memasuki waktu pagi dan petang, dengan nikmat-Mu kami hidup dan mati, dan kepada-Mu kami akan dikembalikan.",
    english: "O Allah, by Your favor we enter the morning and evening, by Your favor we live and die, and to You is the resurrection.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "morning-8",
    category: "morning",
    title: "Memulai Hari dengan Fitrah Islam",
    titleEn: "Starting the Day with Islamic Faith",
    arabic: "أَصْبَحْنَا عَلَى فِطْرَةِ الْإِسْلَامِ وَعَلَى كَلِمَةِ الْإِخْلَاصِ وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ وَعَلَى مِلَّةِ إِبْرَاهِيمَ حَنِيفًا مُسْلِمًا وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
    transliteration: "Asbahna 'ala fitratil islaam wa 'ala kalimatil ikhlaas wa 'ala diini nabiyyina Muhammadin shallallahu alaihi wasallam wa 'ala millati ibrahima hanifan muslima wa ma kaana minal musyrikin",
    indonesian: "Kami memasuki waktu pagi dengan fitrah Islam, dengan kalimat ikhlas, dengan agama nabi kami Muhammad shallallahu alaihi wasallam, dan dengan agama Ibrahim yang lurus dan muslim, dan bukan dari golongan orang-orang musyrik.",
    english: "We enter the morning upon the natural disposition of Islam, upon the word of sincerity, upon the religion of our Prophet Muhammad, peace be upon him, and upon the religion of our father Ibrahim, uprightly devoted to Allah as a Muslim, and he was not of the polytheists.",
    reference: "HR. Ahmad",
    repeat: 1,
  },
  {
    id: "morning-9",
    category: "morning",
    title: "Memohon Ampunan atas Dosa",
    titleEn: "Seeking Forgiveness for Sins",
    arabic: "رَبِّ اغْفِرْ لِي وَتُبْ عَلَيَّ إِنَّكَ أَنْتَ التَّوَّابُ الرَّحِيمُ",
    transliteration: "Rabbighfir li wa tub alayya innaka antat tawwabur rahim",
    indonesian: "Ya Tuhanku, ampunilah dosaku dan terimalah taubatku, sesungguhnya Engkau Maha Penerima Taubat lagi Maha Penyayang.",
    english: "My Lord, forgive me and accept my repentance, indeed You are the Accepting of Repentance, the Merciful.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "morning-10",
    category: "morning",
    title: "Nikmat dari Allah yang Tak Terhitung",
    titleEn: "Countless Blessings from Allah",
    arabic: "اللَّهُمَّ مَا أَصْبَحَ بِي مِنْ نِعْمَةٍ أَوْ بِأَحَدٍ مِنْ خَلْقِكَ فَمِنْكَ وَحْدَكَ لَا شَرِيكَ لَكَ فَلَكَ الْحَمْدُ وَلَكَ الشُّكْرُ",
    transliteration: "Allahumma ma asbaha bi min ni'matin aw bi ahadin min khalqika faminaka wahdaka la syarika lak falakal hamdu wa lakasy syukru",
    indonesian: "Ya Allah, segala nikmat yang pagi ini aku rasakan, baik yang datang dari-Mu atau dari salah satu makhluk-Mu, semuanya hanya dari-Mu Yang Maha Esa, tidak ada sekutu bagi-Mu, bagi-Mu segala puji dan segala terima kasih.",
    english: "O Allah, whatever blessing I have this morning, or any of Your creation, is from You alone, You have no partner, so all praise and gratitude are due to You.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "morning-11",
    category: "morning",
    title: "Dzikir yang Lebih Baik dari Semua",
    titleEn: "Better Than Everything",
    arabic: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ: عَدَدَ خَلْقِهِ وَرِضَا نَفْسِهِ وَزِنَةَ عَرْشِهِ وَمِدَادَ كَلِمَاتِهِ",
    transliteration: "Subhanallahi wa bihamdihi: 'adada khalqihi wa ridha nafsihi wa zinata 'arsyhi wa midada kalimatihi",
    indonesian: "Maha Suci Allah dan segala puji bagi-Nya, sebanyak makhluk-Nya, sesuai kerelaan-Nya, seberat timbangan 'Arsy-Nya, dan sebanyak tinta kalimat-kalimat-Nya.",
    english: "Glory is to Allah and praise is to Him, according to the number of His creation, according to His pleasure, according to the weight of His Throne, and according to the ink of His words.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "morning-12",
    category: "morning",
    title: "Memohon Ilmu dan Rezeki yang Barokah",
    titleEn: "Seeking Beneficial Knowledge and Provision",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا وَرِزْقًا طَيِّبًا وَعَمَلًا مُتَقَبَّلًا",
    transliteration: "Allahumma inni as'aluka 'ilman nafi'an wa rizqan tayyiban wa 'amalan mutaqqabalan",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu ilmu yang bermanfaat, rezeki yang baik, dan amal yang diterima.",
    english: "O Allah, I ask You for beneficial knowledge, goodly provision, and acceptable deeds.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "morning-13",
    category: "morning",
    title: "Memohon Ampunan dan Berkat",
    titleEn: "Seeking Forgiveness and Blessings",
    arabic: "أَسْتَغْفِرُ اللَّهَ الْعَظِيمَ الَّذِي لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ وَأَتُوبُ إِلَيْهِ",
    transliteration: "Astaghfirullaha 'azhimalladzi la ilaha illa huwal hayyul qayyum wa atubu ilaih",
    indonesian: "Aku memohon ampun kepada Allah Yang Maha Agung, tiada Tuhan selain Dia, Yang Hidup kekal lagi terus menerus mengurus makhluk-Nya, dan aku bertaubat kepada-Nya.",
    english: "I seek forgiveness from Allah the Great, besides Whom there is no deity, the Ever-Living, the Sustainer of existence, and I turn to Him in repentance.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "morning-14",
    category: "morning",
    title: "Ketika Memasuki Waktu Pagi",
    titleEn: "Entering the Morning Time",
    arabic: "اللَّهُمَّ أَنْتَ رَبِّي لَا إِلَهَ إِلَّا أَنْتَ، خَلَقْتَنِي وَأَنَا عَبْدُكَ، وَأَنَا عَلَى عَهْدِكَ وَوَعْدِكَ مَا اسْتَطَعْتُ",
    transliteration: "Allahumma anta rabbi la ilaha illa anta, khalaqtani wa ana 'abduka, wa ana 'ala 'ahdika wa wa'dika mastatha'tu",
    indonesian: "Ya Allah, Engkau adalah Tuhanku, tidak ada Tuhan selain Engkau. Engkau telah menciptakanku dan aku adalah hamba-Mu. Aku akan setia pada perjanjianku dan janji-Mu sesuai kemampuanku.",
    english: "O Allah, You are my Lord, there is no god but You. You created me and I am Your servant. I uphold Your covenant and promise as best I can.",
    reference: "HR. Abu Dawud",
    repeat: 3,
  },
  {
    id: "morning-15",
    category: "morning",
    title: "Terbebas dari Api Neraka",
    titleEn: "Freedom from Hellfire",
    arabic: "اللَّهُمَّ أَجِرْنِي مِنَ النَّارِ",
    transliteration: "Allahumma ajirni minan naar",
    indonesian: "Ya Allah, lindungilah aku dari neraka.",
    english: "O Allah, protect me from the Fire.",
    reference: "HR. Bukhari",
    repeat: 7,
  },
  {
    id: "morning-16",
    category: "morning",
    title: "Keselamatan di Dunia dan Akhirat",
    titleEn: "Safety in This World and Hereafter",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ",
    transliteration: "Allahumma inni as'alukal 'afiyah fid dunya wal akhirah",
    indonesian: "Ya Allah, sesungguhnya aku memohon kesejahteraan di dunia dan akhirat.",
    english: "O Allah, I ask You for well-being in this world and the Hereafter.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "morning-17",
    category: "morning",
    title: "Doa Terlepas dari Hutang",
    titleEn: "Supplication for Debt Relief",
    arabic: "اللَّهُمَّ اكْفِنِي بِحَلَالِكَ عَنْ حَرَامِكَ وَأَغْنِنِي بِفَضْلِكَ عَمَّنْ سِوَاكَ",
    transliteration: "Allahumma kfini bihalalika 'an haramik wa aghnini bifaqhlika amman siwaka",
    indonesian: "Ya Allah, cukupkanlah untukku dengan rezeki yang halal-Mu dari yang haram, dan kayakanlah aku dengan karunia-Mu dari selain Engkau.",
    english: "O Allah, suffice me with what You have made lawful and keep me away from what You have made unlawful, and enrich me by Your bounty from everyone else.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "morning-18",
    category: "morning",
    title: "Doa Meminta Kelancaran Rezeki",
    titleEn: "Supplication for Easy Provision",
    arabic: "اللَّهُمَّ بَارِكْ لَهُمْ فِي مَا رَزَقْتَهُمْ وَاغْفِرْ لَهُمْ وَارْحَمْهُمْ",
    transliteration: "Allahumma barik lahum fima razaqtahum waghfir lahum warhamhum",
    indonesian: "Ya Allah, berkahilah rezeki yang Engkau berikan kepada mereka, ampunilah mereka, dan rahmatilah mereka.",
    english: "O Allah, bless them in what You have provided for them, forgive them, and have mercy on them.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "morning-19",
    category: "morning",
    title: "Dzikir Pagi - Tasbih Lengkap",
    titleEn: "Morning - Complete Tasbih",
    arabic: "سُبْحَانَ اللَّهِ (33x) ۝ الْحَمْدُ لِلَّهِ (33x) ۝ اللَّهُ أَكْبَرُ (34x)",
    transliteration: "Subhanallah (33x), Alhamdulillah (33x), Allahu Akbar (34x)",
    indonesian: "Maha Suci Allah (33x), Segala puji bagi Allah (33x), Allah Maha Besar (34x). Total 100x.",
    english: "Glory is to Allah (33x), All praise is due to Allah (33x), Allah is the Greatest (34x). Total 100x.",
    reference: "HR. Bukhari & Muslim",
    repeat: 100,
  },
  {
    id: "morning-20",
    category: "morning",
    title: "La Ilaha Illallah",
    titleEn: "There is no god but Allah",
    arabic: "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    transliteration: "Laa ilaha illallah wahdahu laa syarika lah, lahul mulku wa lahul hamdu wa huwa 'ala kulli syai'in qadir",
    indonesian: "Tidak ada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya. Bagi-Nya kerajaan dan bagi-Nya puji, dan Dia Maha Kuasa atas segala sesuatu.",
    english: "There is no god but Allah alone, He has no partner. His is the dominion and His is the praise, and He is Able to do all things.",
    reference: "HR. Tirmidzi",
    repeat: 100,
  },
  {
    id: "morning-21",
    category: "morning",
    title: "Dua Ayat Terakhir Al-Baqarah",
    titleEn: "Last Two Verses of Al-Baqarah",
    arabic: "آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ ۚ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ ۚ وَقَالُوا سَمِعْنَا وَأَطَعْنَا غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ ۚ لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا رَbَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
    transliteration: "Baca dua ayat terakhir Surat Al-Baqarah (ayat 285-286)",
    indonesian: "Rasulullah, orang mukmin, dan orang yang beriman telah percaya kepada Allah, malaikat-malaikat-Nya, kitab-kitab-Nya, dan rasul-rasul-Nya. Mereka berkata: Kami mendengar dan taat. Ampunilah kami ya Tuhan kami, dan kepada-Mulah tempat kembali. Allah tidak membebani seseorang melainkan sesuai kesanggupannya. Ia mendapat pahala atas kebajikan yang diusahakannya dan ia mendapat siksa atas kejahatan yang dikerjakannya. Ya Tuhan kami, janganlah Engkau menghukum kami jika kami lupa atau kami bersalah. Ya Tuhan kami, janganlah Engkau membebani kami seperti Engkau bebankan kepada orang-orang sebelum kami. Ya Tuhan kami, janganlah Engkau membebani kami apa yang tidak sanggup kami memikulnya. Maafkanlah kami, ampunilah kami, dan rahmatilah kami. Engkau pelindung kami, tolonglah kami terhadap orang-orang kafir.",
    english: "The Messenger has believed in what was revealed to him from his Lord, and so have the believers. All of them have believed in Allah and His angels and His books and His messengers, saying: We hear and obey. Our Lord, forgive us and to You is the return. Allah does not charge a soul except according to its capacity. It will have what it has earned and it will bear the consequences of what it has earned. Our Lord, do not punish us if we forget or make a mistake. Our Lord, do not place upon us a burden like that which You placed upon those before us. Our Lord, do not burden us with that which we have no ability to bear. Pardon us, forgive us, and have mercy upon us. You are our protector, so give us victory over the disbelieving people.",
    reference: "QS. Al-Baqarah: 285-286",
    repeat: 1,
  },
  {
    id: "morning-22",
    category: "morning",
    title: "Perlindungan untuk Umat",
    titleEn: "Supplication for the Ummah",
    arabic: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّةِ مِنْ شَرِّ مَا خَلَقَ",
    transliteration: "A'udzu bikalimatillahit tammati min syarri ma khalaq",
    indonesian: "Aku berlindung dengan kalimat-kalimat Allah yang sempurna dari kejahatan segala sesuatu yang Dia ciptakan.",
    english: "I seek refuge in the perfect words of Allah from the evil of what He has created.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "morning-23",
    category: "morning",
    title: "Memulai Hari dengan Ketaatan",
    titleEn: "Starting the Day with Obedience",
    arabic: "اللَّهُمَّ إِنِّي أَصْبَحْتُ أُشْهِدُكَ وَأُشْهِدُ حَمَلَةَ عَرْشِكَ وَمَلَائِكَتَكَ وَجَمِيعَ خَلْقِكَ أَنَّكَ أَنْتَ اللَّهُ لَا إِلَهَ إِلَّا أَنْتَ وَحْدَكَ لَا شَرِيكَ لَكَ وَأَنَّ مُحَمَّدًا عَبْدُكَ وَرَسُولُكَ",
    transliteration: "Allahumma inni asbahtu ushiduka wa ushidu hamalata 'arsyika wa mala'ikataka wa jami'a khalqika annaka antallahu la ilaha illa anta wahdaka la syarika lak wa anna Muhammadan 'abduka wa rasuluka",
    indonesian: "Ya Allah, sesungguhnya aku memasuki waktu pagi, aku bersaksi bahwa Engkau adalah Allah, tiada Tuhan selain Engkau, Yang Maha Esa, tidak ada sekutu bagi-Mu, dan bahwa Muhammad adalah hamba-Mu dan rasul-Mu.",
    english: "O Allah, I have entered the morning bearing witness to You, and bearers of Your Throne, Your angels, and all Your creation, that You are Allah, there is no god but You, the One, having no partner, and that Muhammad is Your servant and messenger.",
    reference: "HR. Abu Dawud",
    repeat: 4,
  },
  // Evening Dzikir
  {
    id: "evening-1",
    category: "evening",
    title: "Dzikir Petang - Ayat Kursi",
    titleEn: "Evening - Ayat Kursi",
    arabic: "اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَن ذَا الَّذِي يَشْفَعُ عِندَهُ إِلَّا بِإِذْنِهِ ۚ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ",
    transliteration: "Allahu la ilaha illa huwal hayyul qayyum. La ta'khudzuhu sinatuw wa la naum. Lahu ma fis samawati wa ma fil ardh. Man dzal ladzi yasyfa'u 'indahu illa bi idznih. Ya'lamu ma baina aidihim wa ma khalfahum. Wa la yuhituna bi syai'im min 'ilmihi illa bima sya'. Wasi'a kursiyyuhus samawati wal ardh. Wa la ya'uduhu hifzuhuma wa huwal 'aliyyul 'azhim.",
    indonesian: "Allah, tidak ada Tuhan selain Dia Yang Hidup kekal lagi terus menerus mengurus makhluk-Nya. Tidak mengantuk dan tidak tidur. Kepunyaan-Nya apa yang di langit dan di bumi. Tiada yang dapat memberi syafaat di sisi-Nya tanpa izin-Nya. Dia mengetahui apa-apa yang di hadapan mereka dan di belakang mereka, dan mereka tidak mengetahui apa-apa dari ilmu Allah melainkan apa yang dikehendaki-Nya. Kursi Allah meliputi langit dan bumi. Dan Allah tidak merasa berat memelihara keduanya, dan Allah Maha Tinggi lagi Maha Besar.",
    english: "Allah - there is no deity except Him, the Ever-Living, the Sustainer of existence. Neither drowsiness overtakes Him nor sleep. To Him belongs whatever is in the heavens and whatever is on the earth. Who is it that can intercede with Him except by His permission? He knows what is before them and what will be after them, and they encompass not a thing of His knowledge except for what He wills. His Kursi extends over the heavens and the earth, and their preservation tires Him not. And He is the Most High, the Most Great.",
    reference: "QS. Al-Baqarah: 255",
    repeat: 1,
  },
  {
    id: "evening-2",
    category: "evening",
    title: "Surah Al-Ikhlas",
    titleEn: "Surah Al-Ikhlas",
    arabic: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ۝قُلْ هُوَ اللَّهُ أَحَدٌ۝اللَّهُ الصَّمَدُ۝لَمْ يَلِدْ وَلَمْ يُولَدْ۝وَلَمْ يَكُن لَّهُ كُفُوًا أَحَدٌ",
    transliteration: "Bismillahir rahmanir rahim. Qul huwallahu ahad. Allahus shamad. Lam yalid wa lam yulad. Wa lam yakul lahu kufuwan ahad.",
    indonesian: "Dengan menyebut nama Allah Yang Maha Pemurah lagi Maha Penyayang. Katakanlah: Dialah Allah, Yang Maha Esa. Allah adalah Tuhan yang bergantungan kepada-Nya segala sesuatu. Dia tiada beranak dan tidak pula diperanakkan, dan tidak ada seorangpun yang setara dengan Dia.",
    english: "In the name of Allah, the Beneficent, the Merciful. Say: He is Allah, the One. Allah, the Eternal Refuge. He neither begets nor is born. Nor is there to Him any equivalent.",
    reference: "QS. Al-Ikhlas: 1-4",
    repeat: 3,
  },
  {
    id: "evening-3",
    category: "evening",
    title: "Surah Al-Falaq",
    titleEn: "Surah Al-Falaq",
    arabic: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ۝قُلْ أَعُوذُ بِرَبِّ الْفَلَقِ۝مِن شَرِّ مَا خَلَقَ۝وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ۝وَمِن شَرِّ النَّفَّاثَاتِ فِي الْعُقَدِ۝وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ",
    transliteration: "Bismillahir rahmanir rahim. Qul a'udzu birabbil falaq. Min sharri maa khalaq. Wa min sharri ghaasiqin idza waqab. Wa min sharrin naffaatsaati fil 'uqad. Wa min sharri haasidin idza hasad.",
    indonesian: "Dengan menyebut nama Allah Yang Maha Pemurah lagi Maha Penyayang. Katakanlah: Aku berlindung kepada Tuhan Yang Menguasai subuh, dari kejahatan makhluk-Nya, dan dari kejahatan malam apabila telah gelap gulita, dan dari kejahatan wanita-wanita tukang sihir yang menghembus pada buhul-buhul, dan dari kejahatan pendengki bila ia dengki.",
    english: "In the name of Allah, the Beneficent, the Merciful. Say: I seek refuge in the Lord of daybreak, from the evil of that which He created, and from the evil of darkness when it settles, and from the evil of the blowers in knots, and from the evil of an envier when he envies.",
    reference: "QS. Al-Falaq: 1-5",
    repeat: 3,
  },
  {
    id: "evening-4",
    category: "evening",
    title: "Surah An-Nas",
    titleEn: "Surah An-Nas",
    arabic: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ۝قُلْ أَعُوذُ بِرَبِّ النَّاسِ۝مَلِكِ النَّاسِ۝إِلَهِ النَّاسِ۝مِن شَرِّ الْوَسْوَاسِ الْخَنَّاسِ۝الَّذِي يُوَسْوِسُ فِي صُدُورِ النَّاسِ۝مِنَ الْجِنَّةِ وَالنَّاسِ",
    transliteration: "Bismillahir rahmanir rahim. Qul a'udzu birabbin naas. Malikin naas. Ilaahin naas. Min sharril waswaasil khannaas. Alladzi yuwaswisu fi suduurin naas. Minal jinnati wan naas.",
    indonesian: "Dengan menyebut nama Allah Yang Maha Pemurah lagi Maha Penyayang. Katakanlah: Aku berlindung kepada Tuhan manusia. Raja manusia. Sembahan manusia. Dari kejahatan (bisikan) syaitan yang biasa bersembunyi, yang membisikkan (kejahatan) ke dalam dada manusia, dari (golongan) jin dan manusia.",
    english: "In the name of Allah, the Beneficent, the Merciful. Say: I seek refuge in the Lord of mankind, the Sovereign of mankind, the God of mankind, from the evil of the retreating whisperer, who whispers in the breasts of mankind, from among the jinn and mankind.",
    reference: "QS. An-Nas: 1-6",
    repeat: 3,
  },
  {
    id: "evening-5",
    category: "evening",
    title: "Dzikir Petang - Subhanallah",
    titleEn: "Evening - SubhanAllah",
    arabic: "سُبْحَانَ اللَّهِ",
    transliteration: "Subhanallah",
    indonesian: "Maha Suci Allah.",
    english: "Glory is to Allah.",
    reference: "HR. Muslim",
    repeat: 33,
  },
  {
    id: "evening-6",
    category: "evening",
    title: "Dzikir Petang - Alhamdulillah",
    titleEn: "Evening - Alhamdulillah",
    arabic: "الْحَمْدُ لِلَّهِ",
    transliteration: "Alhamdulillah",
    indonesian: "Segala puji bagi Allah.",
    english: "All praise is due to Allah.",
    reference: "HR. Muslim",
    repeat: 33,
  },
  {
    id: "evening-7",
    category: "evening",
    title: "Dzikir Petang - Allahu Akbar",
    titleEn: "Evening - Allahu Akbar",
    arabic: "اللَّهُ أَكْبَرُ",
    transliteration: "Allahu Akbar",
    indonesian: "Allah Maha Besar.",
    english: "Allah is the Greatest.",
    reference: "HR. Muslim",
    repeat: 34,
  },
  {
    id: "evening-8",
    category: "evening",
    title: "Menutup Hari dengan Dzikir",
    titleEn: "Closing the Day with Dhikr",
    arabic: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ",
    transliteration: "Subhanallahi wa bihamdihi",
    indonesian: "Maha Suci Allah dan segala puji bagi-Nya.",
    english: "Glory is to Allah and praise is to Him.",
    reference: "HR. Bukhari & Muslim",
    repeat: 100,
  },
  {
    id: "evening-9",
    category: "evening",
    title: "Memperlakukan Malam dengan Fitrah Islam",
    titleEn: "Ending the Day with Islamic Faith",
    arabic: "أَمْسَيْنَا عَلَى فِطْرَةِ الْإِسْلَامِ وَعَلَى كَلِمَةِ الْإِخْلَاصِ وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ وَعَلَى مِلَّةِ إِبْرَاهِيمَ حَنِيفًا مُسْلِمًا وَمَا كَانَ مِنَ الْمُشْرِكِينَ",
    transliteration: "Amsaina 'ala fitratil islaam wa 'ala kalimatil ikhlaas wa 'ala diini nabiyyina Muhammadin shallallahu alaihi wasallam wa 'ala millati ibrahima hanifan muslima wa ma kaana minal musyrikin",
    indonesian: "Kami memasuki waktu petang dengan fitrah Islam, dengan kalimat ikhlas, dengan agama nabi kami Muhammad shallallahu alaihi wasallam, dan dengan agama Ibrahim yang lurus dan muslim, dan bukan dari golongan orang-orang musyrik.",
    english: "We enter the evening upon the natural disposition of Islam, upon the word of sincerity, upon the religion of our Prophet Muhammad, peace be upon him, and upon the religion of our father Ibrahim, uprightly devoted to Allah as a Muslim, and he was not of the polytheists.",
    reference: "HR. Ahmad",
    repeat: 1,
  },
  {
    id: "evening-10",
    category: "evening",
    title: "Bersyukur atas Nikmat",
    titleEn: "Gratitude for Blessings",
    arabic: "اللَّهُمَّ مَا أَمْسَى بِي مِنْ نِعْمَةٍ أَوْ بِأَحَدٍ مِنْ خَلْقِكَ فَمِنْكَ وَحْدَكَ لَا شَرِيكَ لَكَ فَلَكَ الْحَمْدُ وَلَكَ الشُّكْرُ",
    transliteration: "Allahumma ma amsa bi min ni'matin aw bi ahadin min khalqika faminaka wahdaka la syarika lak falakal hamdu wa lakasy syukru",
    indonesian: "Ya Allah, segala nikmat yang petang ini aku rasakan, baik yang datang dari-Mu atau dari salah satu makhluk-Mu, semuanya hanya dari-Mu Yang Maha Esa, tidak ada sekutu bagi-Mu, bagi-Mu segala puji dan segala terima kasih.",
    english: "O Allah, whatever blessing I have this evening, or any of Your creation, is from You alone, You have no partner, so all praise and gratitude are due to You.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "evening-11",
    category: "evening",
    title: "Memohon Perlindungan di Malam Hari",
    titleEn: "Seeking Night Protection",
    arabic: "اللَّهُمَّ بِكَ أَمْسَيْنَا وَبِكَ أَصْبَحْنَا وَبِكَ نَحْيَا وَبِكَ نَمُوتُ وَإِلَيْكَ الْمَصِيرُ",
    transliteration: "Allahumma bika amsaina wa bika asbahna wa bika nahya wa bika namutu wa ilaikal masir",
    indonesian: "Ya Allah, dengan nikmat-Mu kami memasuki waktu petang dan pagi, dengan nikmat-Mu kami hidup dan mati, dan kepada-Mulah tempat kembali.",
    english: "O Allah, by Your favor we enter the evening and morning, by Your favor we live and die, and to You is the return.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "evening-12",
    category: "evening",
    title: "Memohon Perlindungan dari Keburukan",
    titleEn: "Seeking Refuge from Evil",
    arabic: "أَعُوذُ بِكَلِمَاتِ اللَّهِ التَّامَّاتِ مِنْ شَرِّ مَا خَلَقَ",
    transliteration: "A'udzu bikalimatillahit tammati min syarri ma khalaq",
    indonesian: "Aku berlindung dengan kalimat-kalimat Allah yang sempurna dari kejahatan segala sesuatu yang Dia ciptakan.",
    english: "I seek refuge in the perfect words of Allah from the evil of what He has created.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "evening-13",
    category: "evening",
    title: "Memohon Keselamatan",
    titleEn: "Seeking Safety and Well-being",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ",
    transliteration: "Allahumma inni as'alukal 'afiyah fid dunya wal akhirah",
    indonesian: "Ya Allah, sesungguhnya aku memohon kesejahteraan di dunia dan akhirat.",
    english: "O Allah, I ask You for well-being in this world and the Hereafter.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "evening-14",
    category: "evening",
    title: "Memohon Ampunan",
    titleEn: "Seeking Forgiveness",
    arabic: "أَسْتَغْفِرُ اللَّهَ وَأَتُوبُ إِلَيْهِ",
    transliteration: "Astaghfirullaha wa atubu ilaih",
    indonesian: "Aku memohon ampun kepada Allah dan bertaubat kepada-Nya.",
    english: "I seek forgiveness from Allah and turn to Him in repentance.",
    reference: "HR. Abu Dawud",
    repeat: 100,
  },
  {
    id: "evening-15",
    category: "evening",
    title: "Menjaga Iman di Malam Hari",
    titleEn: "Maintaining Faith in the Evening",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ أَنْ أُشْرِكَ بِكَ شَيْئًا أَعْلَمُهُ وَأَسْتَغْفِرُكَ لِمَا لَا أَعْلَمُهُ",
    transliteration: "Allahumma inni a'udzu bika an usyrika bika syai'an a'lamuhu wa astaghfiruka lima la a'lamuhu",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari mempersekutukan-Mu dengan sesuatu yang aku ketahui, dan aku memohon ampunan kepada-Mu dari apa yang tidak aku ketahui.",
    english: "O Allah, I seek refuge in You from associating anything with You knowingly, and I seek Your forgiveness for what I do unknowingly.",
    reference: "HR. Ahmad",
    repeat: 3,
  },
  {
    id: "evening-16",
    category: "evening",
    title: "Perlindungan dari Siksa Kubur",
    titleEn: "Protection from Grave Punishment",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ عَذَابِ الْقَبْرِ وَمِنْ عَذَابِ جَهَنَّمَ وَمِنْ فِتْنَةِ الْمَحْيَا وَالْمَمَاتِ وَمِنْ فِتْنَةِ الْمَسِيحِ الدَّجَّالِ",
    transliteration: "Allahumma inni a'udzu bika min 'adhabil qabri wa min 'adhabi jahannama wa min fitnatil mahya wal mamati wa min fitnatil masihid dajjal",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari siksa kubur, dari siksa neraka jahanam, dari fitnah kehidupan dan kematian, serta fitnah Dajjal.",
    english: "O Allah, I seek refuge in You from the punishment of the grave, from the punishment of Hellfire, from the trials of life and death, and from the trials of the False Messiah.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "evening-17",
    category: "evening",
    title: "Dzikir yang Lebih Baik",
    titleEn: "Better Than Everything",
    arabic: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ: عَدَدَ خَلْقِهِ وَرِضَا نَفْسِهِ وَزِنَةَ عَرْشِهِ وَمِدَادَ كَلِمَاتِهِ",
    transliteration: "Subhanallahi wa bihamdihi: 'adada khalqihi wa ridha nafsihi wa zinata 'arsyhi wa midada kalimatihi",
    indonesian: "Maha Suci Allah dan segala puji bagi-Nya, sebanyak makhluk-Nya, sesuai kerelaan-Nya, seberat timbangan 'Arsy-Nya, dan sebanyak tinta kalimat-kalimat-Nya.",
    english: "Glory is to Allah and praise is to Him, according to the number of His creation, according to His pleasure, according to the weight of His Throne, and according to the ink of His words.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "evening-18",
    category: "evening",
    title: "Memohon Ilmu dan Rezeki",
    titleEn: "Seeking Knowledge and Provision",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ عِلْمًا نَافِعًا وَرِزْقًا طَيِّبًا وَعَمَلًا مُتَقَبَّلًا",
    transliteration: "Allahumma inni as'aluka 'ilman nafi'an wa rizqan tayyiban wa 'amalan mutaqqabalan",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu ilmu yang bermanfaat, rezeki yang baik, dan amal yang diterima.",
    english: "O Allah, I ask You for beneficial knowledge, goodly provision, and acceptable deeds.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "evening-19",
    category: "evening",
    title: "Terhindar dari Api Neraka",
    titleEn: "Protection from Hellfire",
    arabic: "اللَّهُمَّ أَجِرْنِي مِنَ النَّارِ",
    transliteration: "Allahumma ajirni minan naar",
    indonesian: "Ya Allah, lindungilah aku dari neraka.",
    english: "O Allah, protect me from the Fire.",
    reference: "HR. Bukhari",
    repeat: 7,
  },
  {
    id: "evening-20",
    category: "evening",
    title: "Istighfar Terbaik",
    titleEn: "Best Seeking Forgiveness",
    arabic: "أَسْتَغْفِرُ اللَّهَ الْعَظِيمَ الَّذِي لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ وَأَتُوبُ إِلَيْهِ",
    transliteration: "Astaghfirullaha 'azhimalladzi la ilaha illa huwal hayyul qayyum wa atubu ilaih",
    indonesian: "Aku memohon ampun kepada Allah Yang Maha Agung, tiada Tuhan selain Dia, Yang Hidup kekal lagi terus menerus mengurus makhluk-Nya, dan aku bertaubat kepada-Nya.",
    english: "I seek forgiveness from Allah the Great, besides Whom there is no deity, the Ever-Living, the Sustainer of existence, and I turn to Him in repentance.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "evening-21",
    category: "evening",
    title: "Keridaan Allah",
    titleEn: "Seeking Allah's Pleasure",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الرِّضَى بَعْدَ الْقَضَاءِ وَأَسْأَلُكَ عَيْشًا رَاضِيًا وَأَسْأَلُكَ نَعِيمًا لَا يَبِيدُ وَأَسْأَلُكَ الْفَرَحَةَ الدَّائِمَةَ",
    transliteration: "Allahumma inni as'aluka ridha ba'dal qadha'i wa as'aluka 'aisyan radiyyan wa as'aluka na'iiman la yabidu wa as'aluka farhada da'imah",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu kerelaan setelah ketetapan, dan aku memohon kehidupan yang diridhoi, dan nikmat yang tidak kekal, dan kebahagiaan yang abadi.",
    english: "O Allah, I ask You for contentment after Your decree, for a pleasing life, for everlasting bliss, and for continuous joy.",
    reference: "HR. Ibn Majah",
    repeat: 3,
  },
  {
    id: "evening-22",
    category: "evening",
    title: "Doa Sebelum Tidur",
    titleEn: "Before Sleeping",
    arabic: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
    transliteration: "Bismika Allahumma amutu wa ahya",
    indonesian: "Dengan nama-Mu ya Allah aku mati dan aku hidup.",
    english: "In Your name O Allah, I die and I live.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "evening-23",
    category: "evening",
    title: "Dzikir Petang - Tasbih Lengkap",
    titleEn: "Evening - Complete Tasbih",
    arabic: "سُبْحَانَ اللَّهِ (33x) ۝ الْحَمْدُ لِلَّهِ (33x) ۝ اللَّهُ أَكْبَرُ (34x)",
    transliteration: "Subhanallah (33x), Alhamdulillah (33x), Allahu Akbar (34x)",
    indonesian: "Maha Suci Allah (33x), Segala puji bagi Allah (33x), Allah Maha Besar (34x). Total 100x.",
    english: "Glory is to Allah (33x), All praise is due to Allah (33x), Allah is the Greatest (34x). Total 100x.",
    reference: "HR. Bukhari & Muslim",
    repeat: 100,
  },
  {
    id: "evening-24",
    category: "evening",
    title: "La Ilaha Illallah",
    titleEn: "There is no god but Allah",
    arabic: "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    transliteration: "Laa ilaha illallah wahdahu laa syarika lah, lahul mulku wa lahul hamdu wa huwa 'ala kulli syai'in qadir",
    indonesian: "Tidak ada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya. Bagi-Nya kerajaan dan bagi-Nya puji, dan Dia Maha Kuasa atas segala sesuatu.",
    english: "There is no god but Allah alone, He has no partner. His is the dominion and His is the praise, and He is Able to do all things.",
    reference: "HR. Tirmidzi",
    repeat: 100,
  },
  {
    id: "evening-25",
    category: "evening",
    title: "Dua Ayat Terakhir Al-Baqarah",
    titleEn: "Last Two Verses of Al-Baqarah",
    arabic: "آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ...",
    transliteration: "Baca dua ayat terakhir Surat Al-Baqarah (ayat 285-286)",
    indonesian: "Dua ayat terakhir Al-Baqarah (ayat 285-286) - sama seperti pagi",
    english: "Recite the last two verses of Al-Baqarah (verses 285-286) - same as morning",
    reference: "QS. Al-Baqarah: 285-286",
    repeat: 1,
  },
  {
    id: "evening-26",
    category: "evening",
    title: "Menutup Malam dengan Ketaatan",
    titleEn: "Ending the Day with Obedience",
    arabic: "اللَّهُمَّ إِنِّي أَمْسَيْتُ أُشْهِدُكَ وَأُشْهِدُ حَمَلَةَ عَرْشِكَ وَمَلَائِكَتَكَ وَجَمِيعَ خَلْقِكَ أَنَّكَ أَنْتَ اللَّهُ لَا إِلَهَ إِلَّا أَنْتَ وَحْدَكَ لَا شَرِيكَ لَكَ وَأَنَّ مُحَمَّدًا عَبْدُكَ وَرَسُولُكَ",
    transliteration: "Allahumma inni amsaytu ushiduka wa ushidu hamalata 'arsyika wa mala'ikataka wa jami'a khalqika annaka antallahu la ilaha illa anta wahdaka la syarika lak wa anna Muhammadan 'abduka wa rasuluka",
    indonesian: "Ya Allah, sesungguhnya aku memasuki waktu petang, aku bersaksi bahwa Engkau adalah Allah, tiada Tuhan selain Engkau, Yang Maha Esa, tidak ada sekutu bagi-Mu, dan bahwa Muhammad adalah hamba-Mu dan rasul-Mu.",
    english: "O Allah, I have entered the evening bearing witness to You, and bearers of Your Throne, Your angels, and all Your creation, that You are Allah, there is no god but You, the One, having no partner, and that Muhammad is Your servant and messenger.",
    reference: "HR. Abu Dawud",
    repeat: 4,
  },
  // Prayer Duas
  {
    id: "prayer-1",
    category: "prayer",
    title: "Doa Setelah Adzan",
    titleEn: "After Adhan",
    arabic: "اللَّهُمَّ رَبَّ هَذِهِ الدَّعْوَةِ التَّامَّةِ وَالصَّلاَةِ الْقَائِمَةِ آتِ مُحَمَّدًا الْوَسِيلَةَ وَالْفَضِيلَةَ وَابْعَثْهُ مَقَامًا مَحْمُودًا الَّذِي وَعَدْتَهُ",
    transliteration: "Allahumma rabba hadzihid da'watit taammah, wash sholatil qo'imah, aati Muhammadanil wasilata wal fadhilah, wab'atshu maqomam mahmuudanil ladzi wa'adtah",
    indonesian: "Ya Allah, Tuhan pemilik panggilan yang sempurna ini dan shalat yang akan didirikan, berikanlah kepada Muhammad wasilah dan keutamaan, dan bangkitkanlah beliau pada kedudukan terpuji yang telah Engkau janjikan.",
    english: "O Allah, Lord of this perfect call and established prayer, grant Muhammad the intercession and favor, and raise him to the praised station You have promised him.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "prayer-2",
    category: "prayer",
    title: "Doa Setelah Sholat",
    titleEn: "After Prayer",
    arabic: "أَسْتَغْفِرُ اللَّهَ أَسْتَغْفِرُ اللَّهَ أَسْتَغْفِرُ اللَّهَ",
    transliteration: "Astaghfirullah, Astaghfirullah, Astaghfirullah",
    indonesian: "Aku memohon ampun kepada Allah (3x).",
    english: "I seek forgiveness from Allah (3x).",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "prayer-3",
    category: "prayer",
    title: "Tasbih - Subhanallah",
    titleEn: "Tasbih - Glory is to Allah",
    arabic: "سُبْحَانَ اللَّهِ",
    transliteration: "Subhanallah (33x)",
    indonesian: "Maha Suci Allah (33x).",
    english: "Glory is to Allah (33x).",
    reference: "HR. Bukhari & Muslim",
    repeat: 33,
  },
  {
    id: "prayer-4",
    category: "prayer",
    title: "Tahmid - Alhamdulillah",
    titleEn: "Tahmid - All praise is due to Allah",
    arabic: "الْحَمْدُ لِلَّهِ",
    transliteration: "Alhamdulillah (33x)",
    indonesian: "Segala puji bagi Allah (33x).",
    english: "All praise is due to Allah (33x).",
    reference: "HR. Bukhari & Muslim",
    repeat: 33,
  },
  {
    id: "prayer-5",
    category: "prayer",
    title: "Takbir - Allahu Akbar",
    titleEn: "Takbir - Allah is the Greatest",
    arabic: "اللَّهُ أَكْبَرُ",
    transliteration: "Allahu Akbar (34x)",
    indonesian: "Allah Maha Besar (34x).",
    english: "Allah is the Greatest (34x).",
    reference: "HR. Bukhari & Muslim",
    repeat: 34,
  },
  {
    id: "prayer-6",
    category: "prayer",
    title: "Tahlil - La Ilaha Illallah",
    titleEn: "Tahlil - There is no god but Allah",
    arabic: "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    transliteration: "Laa ilaha illallah wahdahu laa syarika lah, lahul mulku wa lahul hamdu wa huwa 'ala kulli syai'in qadir",
    indonesian: "Tidak ada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya. Bagi-Nya kerajaan dan bagi-Nya puji, dan Dia Maha Kuasa atas segala sesuatu.",
    english: "There is no god but Allah alone, He has no partner. His is the dominion and His is the praise, and He is Able to do all things.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "prayer-7",
    category: "prayer",
    title: "Dzikir Setelah Sholat - Lengkap",
    titleEn: "Complete Dhikr After Prayer",
    arabic: "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، اللَّهُمَّ لَا مَانِعَ لِمَا أَعْطَيْتَ وَلَا مُعْطِيَ لِمَا مَنَعْتَ وَلَا يَنْفَعُ ذَا الْجَدِّ مِنْكَ الْجَدُّ",
    transliteration: "Laa ilaha illallah wahdahu laa syarika lah, lahul mulku wa lahul hamdu wa huwa 'ala kulli syai'in qadir. Allahumma la maani'a lima a'thaita wa la mu'tiya lima mana'ta wa la yanfa'u dzal jaddi minal jadd",
    indonesian: "Tidak ada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya. Bagi-Nya kerajaan dan bagi-Nya puji, dan Dia Maha Kuasa atas segala sesuatu. Ya Allah, tidak ada yang dapat mencegah apa yang Engkau beri, dan tidak ada yang dapat memberi apa yang Engkau cegah, dan keberuntungan seorang yang beruntung tidak bermanfaat dari keberuntungan itu (tanpa pertolongan-Mu).",
    english: "There is no god but Allah alone, He has no partner. His is the dominion and His is the praise, and He is Able to do all things. O Allah, none can deny what You bestow and none can bestow what You deny, and the fortune of the fortunate person avails him nothing against You.",
    reference: "HR. Bukhari & Muslim",
    repeat: 1,
  },
  {
    id: "prayer-8",
    category: "prayer",
    title: "Shalawat kepada Nabi",
    titleEn: "Salawat upon the Prophet",
    arabic: "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ، اللَّهُمَّ بَارِكْ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ",
    transliteration: "Allahumma shalli 'ala Muhammad wa 'ala ali Muhammad kama shallaita 'ala Ibrahim wa 'ala ali Ibrahim innaka Hamidum Majid. Allahumma barik 'ala Muhammad wa 'ala ali Muhammad kama barakta 'ala Ibrahim wa 'ala ali Ibrahim innaka Hamidum Majid",
    indonesian: "Ya Allah, berilah shalawat kepada Muhammad dan keluarga Muhammad sebagaimana Engkau telah memberikan shalawat kepada Ibrahim dan keluarga Ibrahim. Sesungguhnya Engkau Maha Terpuji lagi Maha Mulia. Ya Allah, berkahilah Muhammad dan keluarga Muhammad sebagaimana Engkau telah memberkati Ibrahim dan keluarga Ibrahim. Sesungguhnya Engkau Maha Terpuji lagi Maha Mulia.",
    english: "O Allah, send prayers upon Muhammad and upon the family of Muhammad, as You sent prayers upon Ibrahim and upon the family of Ibrahim. You are indeed Worthy of Praise, Full of Glory. O Allah, bless Muhammad and the family of Muhammad, as You blessed Ibrahim and the family of Ibrahim. You are indeed Worthy of Praise, Full of Glory.",
    reference: "HR. Bukhari & Muslim",
    repeat: 1,
  },
  {
    id: "prayer-9",
    category: "prayer",
    title: "Doa Penyudah - Muhasabah",
    titleEn: "Closing Prayer - Self-Accountability",
    arabic: "اللَّهُمَّ أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ وَحُسْنِ عِبَادَتِكَ",
    transliteration: "Allahumma a'inni 'ala dzikrika wa syukrika wa husni 'ibadatik",
    indonesian: "Ya Allah, bantulah aku untuk mengingat-Mu, bersyukur kepada-Mu, dan memperbaiki ibadah kepada-Mu.",
    english: "O Allah, help me to remember You, give thanks to You, and worship You in the best manner.",
    reference: "HR. Abu Dawud & Nasai",
    repeat: 1,
  },
  {
    id: "prayer-10",
    category: "prayer",
    title: "Doa Memohon Perlindungan dari Keburukan",
    titleEn: "Seeking Refuge from Evil",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْجُبْنِ وَأَعُوذُ بِكَ أَنْ أُرَدَّ إِلَى أَرْذَلِ الْعُمُرِ وَأَعُوذُ بِكَ مِنْ فِتْنَةِ الدُّنْيَا وَأَعُوذُ بِكَ مِنْ عَذَابِ الْقَبْرِ",
    transliteration: "Allahumma inni a'udzu bika minal jubni wa a'udzu bika an uradda ila arzalil 'umuri wa a'udzu bika min fitnatid dunya wa a'udzu bika min 'adhabil qabri",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari kepengecutan, dan aku berlindung kepada-Mu dari dikembalikan ke usia yang tercela, dan aku berlindung kepada-Mu dari fitnah dunia, dan aku berlindung kepada-Mu dari siksa kubur.",
    english: "O Allah, I seek refuge in You from cowardice, and I seek refuge in You from being brought back to a lowly state, and I seek refuge in You from the trials of this world, and I seek refuge in You from the punishment of the grave.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "prayer-11",
    category: "prayer",
    title: "Doa Kebaikan Dunia Akhirat",
    titleEn: "Goodness in This World and the Hereafter",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ، اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي دِينِي وَدُنْيَايَ وَأَهْلِي وَمَالِي، اللَّهُمَّ اسْتُرْ عَوْرَاتِي وَآمِنْ رَوْعَاتِي، اللَّهُمَّ احْفَظْنِي مِنْ بَيْنِ يَدَيَّ وَمِنْ خَلْفِي وَعَنْ يَمِينِي وَعَنْ شِمَالِي، وَمِنْ فَوْقِي، وَأَعُوذُ بِعَظَمَتِكَ أَنْ أُغْتَالَ مِنْ تَحْتِي",
    transliteration: "Allahumma inni as'alukal 'afwa wal 'afiyah fid dunya wal akhirah. Allahumma inni as'alukal 'afwa wal 'afiyah fiddini wa dunyaya wa ahli wa mali. Allahumma astur 'awrati wa amin raw'ati. Allahumma hafizhni min bayni yadayya wa min khalfi wa 'an yamini wa 'an syimali wa min fawqi, wa a'udzu bi'azhamatika an ughtala min tahti",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu kebaikan dan keselamatan di dunia dan akhirat. Ya Allah, sesungguhnya aku memohon kepada-Mu kebaikan dan keselamatan dalam agama, duniaku, keluargaku, dan hartaku. Ya Allah, tutupilah auratku dan tenteramkanlah ketakutanku. Ya Allah, peliharalah aku dari hadapanku, dari belakangku, dari kananku, dari kiriku, dan dari atasku. Dan aku berlindung dengan kebesaran-Mu agar aku dicelakai dari bawahku.",
    english: "O Allah, I ask You for pardon and well-being in this world and the Hereafter. O Allah, I ask You for pardon and well-being in my religion, my worldly affairs, my family, and my wealth. O Allah, conceal my faults and calm my fears. O Allah, guard me from before me and behind me, from my right and my left, and from above me. And I seek refuge in Your greatness from being struck from beneath me.",
    reference: "HR. Ibn Majah",
    repeat: 1,
  },
  {
    id: "prayer-12",
    category: "prayer",
    title: "Taubat - Istighfar",
    titleEn: "Repentance - Seeking Forgiveness",
    arabic: "أَسْتَغْفِرُ اللَّهَ الْعَظِيمَ الَّذِي لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ وَأَتُوبُ إِلَيْهِ",
    transliteration: "Astaghfirullaha 'azhimalladzi la ilaha illa huwal hayyul qayyum wa atubu ilaih",
    indonesian: "Aku memohon ampun kepada Allah Yang Maha Agung, tiada Tuhan selain Dia, Yang Hidup kekal lagi terus menerus mengurus makhluk-Nya, dan aku bertaubat kepada-Nya.",
    english: "I seek forgiveness from Allah the Great, besides Whom there is no deity, the Ever-Living, the Sustainer of existence, and I turn to Him in repentance.",
    reference: "HR. Tirmidzi",
    repeat: 3,
  },
  {
    id: "prayer-13",
    category: "prayer",
    title: "Doa Memohon Ampunan Dosa",
    titleEn: "Seeking Forgiveness for Sins",
    arabic: "اللَّهُمَّ اغْفِرْ لِي ذَنْبِي كُلَّهُ، دِقَّهُ وَجِلَّهُ، وَأَوَّلَهُ وَآخِرَهُ، وَعَلَانِيَتَهُ وَسِرَّهُ",
    transliteration: "Allahumma ghfir li dzanbi kullahu, diqqahu wa jillahu, wa awwalahu wa akhirahu, wa 'alaniyatahu wa sirrahu",
    indonesian: "Ya Allah, ampunilah dosaku seluruhnya, baik yang kecil maupun yang besar, yang awal dan yang akhir, yang lahir dan yang batin.",
    english: "O Allah, forgive me all my sins, the small and the great, the first and the last, the open and the hidden.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "prayer-14",
    category: "prayer",
    title: "Doa Memohon Kebahagiaan",
    titleEn: "Seeking Happiness",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْهُدَى وَالتُّقَى وَالْعَفَافَ وَالْغِنَى",
    transliteration: "Allahumma inni as'alukal hada wat taq wal 'afafal ghina",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu petunjuk, kesalehan, menjaga diri, dan kecukupan.",
    english: "O Allah, I ask You for guidance, piety, chastity, and self-sufficiency.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "prayer-15",
    category: "prayer",
    title: "Doa Memohon Jalan yang Lurus",
    titleEn: "Seeking the Straight Path",
    arabic: "اللَّهُمَّ رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
    transliteration: "Allahumma rabba atina fid dunya hasanah wa fil akhirati hasanah wa qina 'adhaban nar",
    indonesian: "Ya Allah, Tuhan kami, berilah kami kebaikan di dunia dan kebaikan di akhirat, dan peliharalah kami dari siksa neraka.",
    english: "O Allah, our Lord, give us good in this world and good in the Hereafter, and save us from the punishment of the Fire.",
    reference: "QS. Al-Baqarah: 201",
    repeat: 3,
  },
  // Daily Duas
  {
    id: "daily-1",
    category: "daily",
    title: "Doa Keluar Rumah",
    titleEn: "Leaving Home",
    arabic: "بِسْمِ اللَّهِ تَوَكَّلْتُ عَلَى اللَّهِ وَلَا حَوْلَ وَلَا قُوَّةَ إِلَّا بِاللَّهِ",
    transliteration: "Bismillahi tawakkaltu 'alallahi wa la hawla wa la quwwata illa billah",
    indonesian: "Dengan nama Allah, aku bertawakal kepada Allah, tidak ada daya dan kekuatan kecuali dengan pertolongan Allah.",
    english: "In the name of Allah, I place my trust in Allah, there is no might nor power except with Allah.",
    reference: "HR. Abu Dawud & Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-2",
    category: "daily",
    title: "Doa Masuk Rumah",
    titleEn: "Entering Home",
    arabic: "بِسْمِ اللَّهِ وَلَجْنَا وَبِسْمِ اللَّهِ خَرَجْنَا وَعَلَى اللَّهِ رَبِّنَا تَوَكَّلْنَا",
    transliteration: "Bismillahi walajna, wa bismillahi kharajna, wa 'alallahi rabbina tawakkalna",
    indonesian: "Dengan nama Allah kami masuk, dengan nama Allah kami keluar, dan kepada Allah Tuhan kami, kami bertawakal.",
    english: "In the name of Allah we enter, in the name of Allah we leave, and upon Allah our Lord we rely.",
    reference: "HR. Abu Dawud",
    repeat: 1,
  },
  // Eating Duas
  {
    id: "daily-26",
    category: "daily",
    title: "Doa Sebelum Makan",
    titleEn: "Before Eating",
    arabic: "بِسْمِ اللَّهِ وَعَلَى بَرَكَةِ اللَّهِ",
    transliteration: "Bismillahi wa 'ala barakatillah",
    indonesian: "Dengan nama Allah dan dengan berkah Allah.",
    english: "In the name of Allah and with the blessings of Allah.",
    reference: "HR. Abu Dawud",
    repeat: 1,
  },
  {
    id: "daily-27",
    category: "daily",
    title: "Doa Setelah Makan",
    titleEn: "After Eating",
    arabic: "اَلْحَمْدُ لِلَّهِ الَّذِي أَطْعَمَنَا وَسَقَانَا وَجَعَلَنَا مِنَ الْمُسْلِمِينَ",
    transliteration: "Alhamdulillahilladzi ath'amana wa saqana wa ja'alana minal muslimin",
    indonesian: "Segala puji bagi Allah yang telah memberi kami makan dan minum serta menjadikan kami termasuk orang-orang muslim.",
    english: "All praise is for Allah who fed us and gave us drink and made us Muslims.",
    reference: "HR. Abu Dawud & Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-3",
    category: "daily",
    title: "Doa Bangun Tidur",
    titleEn: "Waking Up",
    arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
    transliteration: "Alhamdulillahilladzii ahyaanaa ba'da maa amaatanaa wa ilaihin nusyuur",
    indonesian: "Segala puji bagi Allah yang telah menghidupkan kami setelah mematikan kami dan kepada-Nya kami akan dikembalikan.",
    english: "All praise is for Allah who gave us life after having taken it from us and unto Him is the resurrection.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "daily-4",
    category: "daily",
    title: "Doa Masuk Masjid",
    titleEn: "Entering Mosque",
    arabic: "اللَّهُمَّ افْتَحْ لِي أَبْوَابَ رَحْمَتِكَ",
    transliteration: "Allahumma iftah li abwaba rahmatik",
    indonesian: "Ya Allah, bukalah untukku pintu-pintu rahmat-Mu.",
    english: "O Allah, open the doors of Your Mercy for me.",
    reference: "HR. Muslim",
    repeat: 1,
  },
  {
    id: "daily-5",
    category: "daily",
    title: "Doa Keluar Masjid",
    titleEn: "Leaving Mosque",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ",
    transliteration: "Allahumma inni as'aluka min fadhlik",
    indonesian: "Ya Allah, sesungguhnya aku memohon karunia-Mu.",
    english: "O Allah, I ask You for Your bounty.",
    reference: "HR. Muslim",
    repeat: 1,
  },
  {
    id: "daily-6",
    category: "daily",
    title: "Doa Masuk Kamar Mandi",
    titleEn: "Entering Bathroom",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْخُبُثِ وَالْخَبَائِثِ",
    transliteration: "Allahumma inni a'udzu bika minal khubutsi wal khabaa'its",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari godaan syaitan laki-laki dan perempuan.",
    english: "O Allah, I seek refuge in You from male and female devils.",
    reference: "HR. Bukhari & Muslim",
    repeat: 1,
  },
  {
    id: "daily-7",
    category: "daily",
    title: "Doa Keluar Kamar Mandi",
    titleEn: "Leaving Bathroom",
    arabic: "غُفْرَانَكَ الْحَمْدُ لِلَّهِ الَّذِي أَذْهَبَ عَنِّي الْأَذَى وَعَافَانِي",
    transliteration: "Ghufranaka, alhamdulillahilladzii adzhaba 'annil adza wa 'aafaanii",
    indonesian: "Aku memohon ampunan-Mu, segala puji bagi Allah yang telah menghilangkan kotoran dariku dan telah memberikan kesehatan kepadaku.",
    english: "I seek Your forgiveness. All praise is to Allah who has removed the discomfort from me and granted me well-being.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-8",
    category: "daily",
    title: "Doa Berpakaian",
    titleEn: "Wearing Clothes",
    arabic: "الْحَمْدُ لِلَّهِ الَّذِي كَسَانِي هَذَا وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلَا قُوَّةٍ",
    transliteration: "Alhamdulillahilladzii kasaani hadza wa razaqaniihi min ghowri hawlin minni wa la quwwah",
    indonesian: "Segala puji bagi Allah yang telah memberi pakaian ini kepadaku dan memberikan rezeki kepadaku tanpa daya dan kekuatan dariku.",
    english: "All praise is to Allah Who has clothed me with this garment and provided it for me without any might or power from myself.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-9",
    category: "daily",
    title: "Doa Berpakaian Baru",
    titleEn: "Wearing New Clothes",
    arabic: "اللَّهُمَّ لَكَ الْحَمْدُ أَنْتَ كَسَوْتَنِيهِ أَسْأَلُكَ مِنْ خَيْرِهِ وَخَيْرِ مَا صُنِعَ لَهُ وَأَعُوذُ بِكَ مِنْ شَرِّهِ وَشَرِّ مَا صُنِعَ لَهُ",
    transliteration: "Allahumma lakal hamdu anta kasautanihi, as'aluka min khairihi wa khaira ma su'ina lah, wa a'udzu bika min syarrihi wa syarri ma su'ina lah",
    indonesian: "Ya Allah, bagi-Mu segala puji. Engkaulah yang memberikan pakaian ini kepadaku. Aku memohon kebaikan pakaian ini dan kebaikan apa yang dengannya dibuat, dan aku berlindung kepada-Mu dari kejahatannya dan kejahatan apa yang dengannya dibuat.",
    english: "O Allah, all praise is to You. You have clothed me. I ask You for its goodness and the goodness of what it has been made for, and I seek refuge in You from its evil and the evil of what it has been made for.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-10",
    category: "daily",
    title: "Doa Melepas Pakaian",
    titleEn: "Removing Clothes",
    arabic: "بِسْمِ اللَّهِ",
    transliteration: "Bismillah",
    indonesian: "Dengan nama Allah.",
    english: "In the name of Allah.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-11",
    category: "daily",
    title: "Doa Melihat Cermin",
    titleEn: "Looking in Mirror",
    arabic: "اللَّهُمَّ كَمَا حَسَّنْتَ خَلْقِي فَحَسِّنْ خُلُقِي",
    transliteration: "Allahumma kama hassanta khalqi fahassin khulqi",
    indonesian: "Ya Allah, sebagaimana Engkau telah membuat indah penciptaanku, maka jelaskanlah akhlakku.",
    english: "O Allah, just as You have made my external features beautiful, make my character beautiful as well.",
    reference: "HR. Ahmad",
    repeat: 1,
  },
  {
    id: "daily-12",
    category: "daily",
    title: "Doa Kencing & Buang Air Besar",
    titleEn: "In Toilet",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنَ الْخُبُثِ وَالْخَبَائِثِ",
    transliteration: "Allahumma inni a'udzu bika minal khubutsi wal khabaa'its",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari godaan syaitan laki-laki dan perempuan.",
    english: "O Allah, I seek refuge in You from male and female devils.",
    reference: "HR. Bukhari & Muslim",
    repeat: 1,
  },
  {
    id: "daily-13",
    category: "daily",
    title: "Doa Untuk Kedua Orang Tua",
    titleEn: "For Parents",
    arabic: "رَبِّ اغْفِرْ لِي وَلِوَالِدَيَّ وَارْحَمْهُمَا كَمَا رَبَّيَانِي صَغِيرًا",
    transliteration: "Rabbighfir li wa li walidayya, warham huma kama rabbayani saghira",
    indonesian: "Ya Tuhanku, ampunilah aku dan kedua orang tuaku, dan rahmatilah mereka sebagaimana mereka merawat aku waktu kecil.",
    english: "My Lord, forgive me and my parents, and have mercy upon them as they brought me up when I was small.",
    reference: "QS. Al-Isra: 24",
    repeat: 1,
  },
  {
    id: "daily-14",
    category: "daily",
    title: "Doa Ketika Bergembira",
    titleEn: "When Happy",
    arabic: "تَبًّا لِلْعُبُودِ يَا لَهَا نِعْمَةً",
    transliteration: "Tabban lil 'abudi, yaa laha ni'mah",
    indonesian: "Kecelakaan bagi hamba sahaya, alangkah nikmatnya.",
    english: "Destruction for the slave of the world, oh what a blessing.",
    reference: "Harian",
    repeat: 1,
  },
  {
    id: "daily-15",
    category: "daily",
    title: "Doa Menjenguk Orang Sakit",
    titleEn: "Visiting the Sick",
    arabic: "لَا بَأْسَ طَهُورٌ إِنْ شَاءَ اللَّهُ",
    transliteration: "La ba'sa thahur insya Allah",
    indonesian: "Tidak ada apa-apa, ini penyuci yang insya Allah.",
    english: "No harm, it is a purification if Allah wills.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "daily-16",
    category: "daily",
    title: "Doa Ketika Ada Angin Badai",
    titleEn: "During Storm",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ خَيْرَهَا وَخَيْرَ مَا فِيهَا وَخَيْرَ مَا أُرْسِلَتْ بِهِ وَأَعُوذُ بِكَ مِنْ شَرِّهَا وَشَرِّ مَا فِيهَا وَشَرِّ مَا أُرْسِلَتْ بِهِ",
    transliteration: "Allahumma inni as'aluka khairaha wa khaira ma fiha wa khaira ma ursilat bihi, wa a'udzu bika min sharriha wa sharri ma fiha wa sharri ma ursilat bihi",
    indonesian: "Ya Allah, sesungguhnya aku memohon kebaikan angin ini, kebaikan yang ada di dalamnya, dan kebaikan apa yang dibawanya. Aku berlindung kepada-Mu dari kejahatan angin ini, kejahatan yang ada di dalamnya, dan kejahatan apa yang dibawanya.",
    english: "O Allah, I ask You for the good of this wind, the good of what is in it, and the good of what it is sent with. I seek refuge in You from its evil, the evil of what is in it, and the evil of what it is sent with.",
    reference: "HR. Muslim",
    repeat: 3,
  },
  {
    id: "daily-17",
    category: "daily",
    title: "Doa Ketika Hujan Turun",
    titleEn: "When It Rains",
    arabic: "اللَّهُمَّ صَيِّبًا نَافِعًا",
    transliteration: "Allahumma sayyiban nafi'an",
    indonesian: "Ya Allah, turunkanlah hujan yang bermanfaat.",
    english: "O Allah, make it a beneficial rain.",
    reference: "HR. Bukhari",
    repeat: 3,
  },
  {
    id: "daily-18",
    category: "daily",
    title: "Doa Setelah Hujan",
    titleEn: "After Rain",
    arabic: "مُطِرْنَا بِفَضْلِ اللَّهِ وَرَحْمَتِهِ",
    transliteration: "Muthirna bi fadhllillahi wa rahmatihi",
    indonesian: "Kami telah hujan karena karunia Allah dan rahmat-Nya.",
    english: "We have been given rain by the bounty of Allah and His mercy.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "daily-19",
    category: "daily",
    title: "Doa Masuk Pasar",
    titleEn: "Entering Market",
    arabic: "لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ، يُحْيِي وَيُمِيتُ، وَهُوَ حَيٌّ لَا يَمُوتُ، بِيَدِهِ الْخَيْرُ، وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    transliteration: "Laa ilaha illallahu wahdahu laa syarika lah, lahul mulku wa lahul hamdu, yuhyii wa yumiit, wa huwa hayyun laa yamuut, bi yadihil khair, wa huwa 'ala kulli syai'in qadir",
    indonesian: "Tidak ada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya. Bagi-Nya kerajaan dan bagi-Nya puji. Dia menghidupkan dan mematikan, dan Dia Maha Hidup tidak mati. Di tangan-Nya semua kebaikan, dan Dia Maha Kuasa atas segala sesuatu.",
    english: "There is no god but Allah alone, He has no partner. His is the dominion and His is the praise. He gives life and causes death, and He is Ever-Living and never dies. In His hand is all good, and He has power over all things.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  {
    id: "daily-20",
    category: "daily",
    title: "Doa Berucap dengan Orang Lain",
    titleEn: "Speaking to Others",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ شَرِّ مَا أَعْمَلُ وَمِنْ شَرِّ مَا لَا أَعْمَلُ",
    transliteration: "Allahumma inni a'udzu bika min syarri ma a'malu wa min syarri ma la a'malu",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari kejahatan yang aku kerjakan dan dari kejahatan yang tidak aku kerjakan.",
    english: "O Allah, I seek refuge in You from the evil of what I do and the evil of what I do not do.",
    reference: "HR. Abu Dawud",
    repeat: 3,
  },
  {
    id: "daily-21",
    category: "daily",
    title: "Doa Menjenguk Orang Sakit",
    titleEn: "Visiting the Sick II",
    arabic: "أَذْهِبِ الْبَأْسَ رَبَّ النَّاسِ، وَاشْفِ أَنْتَ الشَّافِي، لَا شِفَاءَ إِلَّا شِفَاؤُكَ، شِفَاءً لَا يُغَادِرُ سَقَمًا",
    transliteration: "Adzihil ba'sa rabban naasi, wasyafi antasy syafi, laa syifaa'a illa syifaa'uka, syifaa'an laa yughadiru saqaman",
    indonesian: "Hilangkanlah penyakit, ya Tuhan manusia, sembuhkanlah, Engkaulah Yang Maha Menyembuhkan, tidak ada kesembuhan kecuali kesembuhan dari-Mu, kesembuhan yang tidak meninggalkan penyakit.",
    english: "Remove the harm, O Lord of mankind, and heal, for You are the Healer, there is no healing except Your healing, a healing that leaves no illness.",
    reference: "HR. Bukhari",
    repeat: 3,
  },
  {
    id: "daily-22",
    category: "daily",
    title: "Doa Ketika Bersin",
    titleEn: "When Sneezing",
    arabic: "الْحَمْدُ لِلَّهِ",
    transliteration: "Alhamdulillah",
    indonesian: "Segala puji bagi Allah.",
    english: "All praise is to Allah.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "daily-23",
    category: "daily",
    title: "Doa Mensucikan Diri",
    titleEn: "Purification",
    arabic: "أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ",
    transliteration: "Asyhhadu alla ilaha illallahu wahdahu laa syarika lah, wa asyhhadu anna Muhammadan 'abduhu wa rasuluh",
    indonesian: "Aku bersaksi bahwa tiada Tuhan selain Allah Yang Maha Esa, tidak ada sekutu bagi-Nya, dan aku bersaksi bahwa Muhammad adalah hamba dan rasul-Nya.",
    english: "I bear witness that there is no god but Allah alone, He has no partner, and I bear witness that Muhammad is His servant and messenger.",
    reference: "HR. Muslim",
    repeat: 1,
  },
  {
    id: "daily-24",
    category: "daily",
    title: "Doa Bangun Pagi",
    titleEn: "Morning Waking",
    arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَATَنَا وَإِلَيْهِ النُّشُورُ",
    transliteration: "Alhamdulillahilladzii ahyaanaa ba'da maa amaatanaa wa ilaihin nusyuur",
    indonesian: "Segala puji bagi Allah yang telah menghidupkan kami setelah mematikan kami dan kepada-Nya kami akan dibangkitkan.",
    english: "All praise is to Allah Who gave us life after causing us to die, and to Him is the return.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  {
    id: "daily-25",
    category: "daily",
    title: "Doa Memakai Pakaian",
    titleEn: "Wearing Garment",
    arabic: "الْحَمْدُ لِلَّهِ الَّذِي كَسَانِي هَذَا الثَّوْبَ وَرَزَقَنِيهِ مِنْ غَيْرِ حَوْلٍ مِنِّي وَلَا قُوَّةٍ",
    transliteration: "Alhamdulillahilladzii kasaanii hadzauts tsauba wa razaqaniihi min ghoiri hawlin minni wa laa quwwah",
    indonesian: "Segala puji bagi Allah yang telah memberi aku pakaian ini dan memberikan rezeki kepadaku tanpa daya dan kekuatan dariku.",
    english: "All praise is to Allah Who has clothed me with this garment and provided it for me without any power or might from myself.",
    reference: "HR. Tirmidzi",
    repeat: 1,
  },
  // Travel Duas
  {
    id: "daily-28",
    category: "daily",
    title: "Doa Naik Kendaraan",
    titleEn: "Riding Vehicle",
    arabic: "سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ",
    transliteration: "Subhanalladzi sakhkhara lana hadza wa ma kunna lahu muqrinin wa inna ila rabbina lamunqalibun",
    indonesian: "Maha Suci Allah yang telah menundukkan semua ini bagi kami padahal kami sebelumnya tidak mampu menguasainya. Dan sesungguhnya kami akan kembali kepada Tuhan kami.",
    english: "Glory to Him who has subjected this to us, and we could never have it by our efforts. And to our Lord we surely must return.",
    reference: "QS. Az-Zukhruf: 13-14",
    repeat: 1,
  },
  {
    id: "daily-29",
    category: "daily",
    title: "Doa Sebelum Tidur",
    titleEn: "Before Sleeping",
    arabic: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا",
    transliteration: "Bismika Allahumma amutu wa ahya",
    indonesian: "Dengan nama-Mu ya Allah aku mati dan aku hidup.",
    english: "In Your name O Allah, I die and I live.",
    reference: "HR. Bukhari",
    repeat: 1,
  },
  // Quran Duas
  {
    id: "quran-1",
    category: "quran-prophet",
    title: "Doa Kebaikan Dunia Akhirat",
    titleEn: "Goodness in This World and Hereafter",
    arabic: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
    transliteration: "Rabbana atina fid-dunya hasanah wa fil-akhirati hasanah wa qina 'adhaban-nar",
    indonesian: "Ya Tuhan kami, berilah kami kebaikan di dunia dan kebaikan di akhirat dan peliharalah kami dari siksa neraka.",
    english: "Our Lord, give us in this world [that which is] good and in the Hereafter [that which is] good and protect us from the punishment of the Fire.",
    reference: "QS. Al-Baqarah: 201",
    repeat: 1,
  },
  {
    id: "quran-2",
    category: "quran-prophet",
    title: "Doa Petunjuk yang Lurus",
    titleEn: "Guidance to the Straight Path",
    arabic: "اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ",
    transliteration: "Ihdinas-siratal mustaqim",
    indonesian: "Tunjukilah kami jalan yang lurus.",
    english: "Guide us to the straight path.",
    reference: "QS. Al-Fatihah: 6",
    repeat: 1,
  },
  {
    id: "quran-3",
    category: "quran-prophet",
    title: "Doa Diberi Hidayah",
    titleEn: "Grant Us Guidance",
    arabic: "رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا وَهَبْ لَنَا مِنْ لَدُنْكَ رَحْمَةً إِنَّكَ أَنْتَ الْوَهَّابُ",
    transliteration: "Rabbana la tuzigh qulubana ba'da idz hadaytana wa hab lana min ladunka rahmah, innaka antal-wahhab",
    indonesian: "Ya Tuhan kami, janganlah Engkau jadikan hati kami condong kepada kesesatan setelah Engkau beri petunjuk kepada kami, dan karuniakanlah kepada kami rahmat dari sisi-Mu. Sesungguhnya Engkau Maha Pemberi.",
    english: "Our Lord, let not our hearts deviate after You have guided us and grant us mercy from Yourself. Truly You are the Bestower.",
    reference: "QS. Ali Imran: 8",
    repeat: 1,
  },
  {
    id: "quran-4",
    category: "quran-prophet",
    title: "Doa Ketenangan Hati",
    titleEn: "Peace and Tranquility",
    arabic: "رَبَّنَا أَفْرِغْ عَلَيْنَا صَبْرًا وَثَبِّتْ أَقْدَامَنَا وَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
    transliteration: "Rabbana aghri 'alayna sabran wa thabbit aqdamana wansurna 'alal-qawmil-kafirin",
    indonesian: "Ya Tuhan kami, tuangkan kesabaran atas kami, dan kukuhkanlah pendirian kami, dan tolonglah kami terhadap orang-orang kafir.",
    english: "Our Lord, pour patience upon us and make our feet firm and help us against the disbelieving people.",
    reference: "QS. Al-Baqarah: 250",
    repeat: 1,
  },
  {
    id: "quran-5",
    category: "quran-prophet",
    title: "Doa Ampunan - Nabi Yunus",
    titleEn: "Forgiveness - Prophet Yunus",
    arabic: "لَا إِلَهَ إِلَّا أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ",
    transliteration: "La ilaha illa anta subhanaka inni kuntu minaz-zalimin",
    indonesian: "Tiada Tuhan selain Engkau, Maha Suci Engkau, sesungguhnya aku termasuk orang-orang yang zalim.",
    english: "There is no deity except You; exalted are You. Indeed, I have been of the wrongdoers.",
    reference: "QS. Al-Anbiya: 87",
    repeat: 1,
  },
  {
    id: "quran-6",
    category: "quran-prophet",
    title: "Doa Keberkahan Ilmu",
    titleEn: "Blessing in Knowledge",
    arabic: "رَبِّ زِدْنِي عِلْمًا",
    transliteration: "Rabbi zidni 'ilma",
    indonesian: "Ya Tuhanku, tambahkanlah kepadaku ilmu.",
    english: "My Lord, increase me in knowledge.",
    reference: "QS. Thaha: 114",
    repeat: 1,
  },
  {
    id: "quran-7",
    category: "quran-prophet",
    title: "Doa Diberi Keturunan yang Baik",
    titleEn: "Righteous Offspring",
    arabic: "رَبِّ هَبْ لِي مِنْ لَدُنْكَ ذُرِّيَّةً طَيِّبَةً إِنَّكَ سَمِيعُ الدُّعَاءِ",
    transliteration: "Rabbi hab li min ladunka dhurriyyatan tayyibah, innaka sami'ud-du'a",
    indonesian: "Ya Tuhanku, anugerahkanlah kepadaku keturunan yang baik dari sisi-Mu. Sesungguhnya Engkau Maha Mendengar doa.",
    english: "My Lord, grant me from Yourself a good offspring. Indeed, You are the Hearing of supplication.",
    reference: "QS. Ali Imran: 38",
    repeat: 1,
  },
  {
    id: "quran-8",
    category: "quran-prophet",
    title: "Doa Dijauhkan dari Keburukan",
    titleEn: "Protection from Evil",
    arabic: "رَبَّنَا إِنَّنَا آمَنَّا فَاغْفِرْ لَنَا ذُنُوبَنَا وَقِنَا عَذَابَ النَّارِ",
    transliteration: "Rabbana innana amanna faghfir lana dhunubana wa qina 'adhaban-nar",
    indonesian: "Ya Tuhan kami, sesungguhnya kami telah beriman, maka ampunilah dosa-dosa kami dan peliharalah kami dari siksa neraka.",
    english: "Our Lord, indeed we have believed, so forgive us our sins and protect us from the punishment of the Fire.",
    reference: "QS. Ali Imran: 16",
    repeat: 1,
  },
  {
    id: "quran-9",
    category: "quran-prophet",
    title: "Doa Orang Tua untuk Anak",
    titleEn: "Parents' Prayer for Children",
    arabic: "رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
    transliteration: "Rabbana hab lana min azwajina wa dhurriyyatina qurrata a'yunin waj'alna lil-muttaqina imama",
    indonesian: "Ya Tuhan kami, anugerahkanlah kepada kami istri-istri dan keturunan kami sebagai penyenang hati kami, dan jadikanlah kami imam bagi orang-orang yang bertakwa.",
    english: "Our Lord, grant us from our spouses and children comfort to our eyes and make us an example for the righteous.",
    reference: "QS. Al-Furqan: 74",
    repeat: 1,
  },
  {
    id: "quran-10",
    category: "quran-prophet",
    title: "Doa Dilipatgandakan Pahala",
    titleEn: "Multiply Good Deeds",
    arabic: "رَبَّنَا آتِنَا مِنْ لَدُنْكَ رَحْمَةً وَهَيِّئْ لَنَا مِنْ أَمْرِنَا رَشَدًا",
    transliteration: "Rabbana atina min ladunka rahmah wa hayyi' lana min amrina rashada",
    indonesian: "Ya Tuhan kami, anugerahkanlah kepada kami rahmat dari sisi-Mu dan sempurnakanlah bagi kami petunjuk yang lurus dalam urusan kami.",
    english: "Our Lord, grant us mercy from Yourself and make for us guidance in our matter.",
    reference: "QS. Al-Kahfi: 10",
    repeat: 1,
  },
  {
    id: "quran-11",
    category: "quran-prophet",
    title: "Doa Diterima Amal",
    titleEn: "Accept Our Deeds",
    arabic: "رَبَّنَا تَقَبَّلْ مِنَّا إِنَّكَ أَنْتَ السَّمِيعُ الْعَلِيمُ",
    transliteration: "Rabbana taqabbal minna innaka antas-sami'ul-'alim",
    indonesian: "Ya Tuhan kami, terimalah (amal) dari kami. Sesungguhnya Engkau Maha Mendengar lagi Maha Mengetahui.",
    english: "Our Lord, accept [this] from us. Indeed You are the Hearing, the Knowing.",
    reference: "QS. Al-Baqarah: 127",
    repeat: 1,
  },
  {
    id: "quran-12",
    category: "quran-prophet",
    title: "Doa Dijauhkan dari Dosa",
    titleEn: "Protection from Sins",
    arabic: "رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا",
    transliteration: "Rabbana la tu'akhidhna in nasina aw akhta'na",
    indonesian: "Ya Tuhan kami, janganlah Engkau hukum kami jika kami lupa atau kami bersalah.",
    english: "Our Lord, do not impose blame upon us if we have forgotten or erred.",
    reference: "QS. Al-Baqarah: 286",
    repeat: 1,
  },
  {
    id: "quran-13",
    category: "quran-prophet",
    title: "Doa Diberi Kekuatan Iman",
    titleEn: "Strengthen Our Faith",
    arabic: "رَبَّنَا لَا تُزِغْ قُلُوبَنَا بَعْدَ إِذْ هَدَيْتَنَا",
    transliteration: "Rabbana la tuzigh qulubana ba'da idz hadaytana",
    indonesian: "Ya Tuhan kami, janganlah Engkau jadikan hati kami condong kepada kesesatan setelah Engkau beri petunjuk kepada kami.",
    english: "Our Lord, do not let our hearts deviate after You have guided us.",
    reference: "QS. Ali Imran: 8",
    repeat: 1,
  },
  {
    id: "quran-14",
    category: "quran-prophet",
    title: "Doa Penutun - Husnul Khatimah",
    titleEn: "Good Ending",
    arabic: "رَبَّنَا أَتْمِمْ لَنَا نُورَنَا وَاغْفِرْ لَنَا إِنَّكَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ",
    transliteration: "Rabbna atmim lana nurana waghfir lana innaka 'ala kulli syai'in qadir",
    indonesian: "Ya Tuhan kami, sempurnakanlah cahaya untuk kami dan ampunilah kami. Sesungguhnya Engkau Maha Kuasa atas segala sesuatu.",
    english: "Our Lord, perfect for us our light and forgive us. Indeed, You are over all things competent.",
    reference: "QS. At-Tahrim: 8",
    repeat: 1,
  },
  {
    id: "quran-15",
    category: "quran-prophet",
    title: "Doa Keberkahan Rezeki",
    titleEn: "Blessed Provision",
    arabic: "رَبِّ أَوْزِعْنِي أَنْ أَشْكُرَ نِعْمَتَكَ الَّتِي أَنْعَمْتَ عَلَيَّ وَعَلَى وَالِدَيَّ وَأَنْ أَعْمَلَ صَالِحًا تَرْضَاهُ وَأَدْخِلْنِي بِرَحْمَتِكَ فِي عِبَادِكَ الصَّالِحِينَ",
    transliteration: "Rabbi awzi'ni an syukra ni'matallati an'amta 'alayya wa 'ala walidayya wa an a'mala shalihan tardhahu wa adkhilni bi-rahmatika fi 'ibadikash-shalihin",
    indonesian: "Ya Tuhanku, berilah ilham kepadaku untuk mensyukuri nikmat-Mu yang telah Engkau anugerahkan kepadaku dan kepada kedua orang tuaku, dan agar aku berbuat amal shalh yang Engkau ridai. Dan masukkanlah aku dengan rahmat-Mu ke dalam golongan hamba-hamba-Mu yang shalih.",
    english: "My Lord, enable me to be grateful for Your favor which You have bestowed upon me and upon my parents and to work righteousness of which You approve. And admit me by Your mercy into [the ranks of] Your righteous servants.",
    reference: "QS. An-Naml: 19",
    repeat: 1,
  },
  {
    id: "quran-16",
    category: "quran-prophet",
    title: "Doa Keselamatan Dunia Akhirat",
    titleEn: "Safety in This World and Hereafter",
    arabic: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الْآخِرَةِ حَسَنَةً وَقِنَا عَذَابَ النَّارِ",
    transliteration: "Rabbana atina fid-dunya hasanah wa fil-akhirati hasanah wa qina 'adhaban-nar",
    indonesian: "Ya Tuhan kami, berilah kami kebaikan di dunia dan kebaikan di akhirat dan peliharalah kami dari siksa neraka.",
    english: "Our Lord, give us in this world [that which is] good and in the Hereafter [that which is] good and protect us from the punishment of the Fire.",
    reference: "QS. Al-Baqarah: 201",
    repeat: 1,
  },
  {
    id: "quran-17",
    category: "quran-prophet",
    title: "Doa Diberi Kemudahan",
    titleEn: "Ease in Affairs",
    arabic: "رَبِّ يَسِّرْ وَلَا تُعَسِّرْ، رَبِّ تَمِّمْ بِالْخَيْرِ",
    transliteration: "Rabbi yassir wa la tu'assir, rabbi tammim bil-khair",
    indonesian: "Ya Tuhanku, mudahkanlah dan jangan Engkau persulit, ya Tuhanku, sempurnakanlah dengan kebaikan.",
    english: "My Lord, make it easy and do not make it difficult, my Lord, complete it with goodness.",
    reference: "HR. Ibn Hibban & Bukhari",
    repeat: 3,
  },
  {
    id: "quran-18",
    category: "quran-prophet",
    title: "Doa Kebaikan Anak - Nabi Ibrahim",
    titleEn: "Righteous Children - Prophet Ibrahim",
    arabic: "رَبِّ اجْعَلْنِي مُقِيمِ الصَّلَاةِ وَمِنْ ذُرِّيَّتِي رَبَّنَا وَتَقَبَّلْ دُعَاءِ",
    transliteration: "Rabbi ja'alni muqimash-shalah wa min dhurriyyati, rabbana wa taqabbal du'a",
    indonesian: "Ya Tuhanku, jadikanlah aku orang yang mendirikan shalat dan juga dari anak cucuku. Ya Tuhan kami, perkenankanlah doa kami.",
    english: "My Lord, make me an establisher of prayer, and [from] my descendants. Our Lord, and accept my supplication.",
    reference: "QS. Ibrahim: 40",
    repeat: 1,
  },
  {
    id: "quran-19",
    category: "quran-prophet",
    title: "Doa Terhindar dari Keburukan",
    titleEn: "Protection from Evil Deeds",
    arabic: "رَبَّنَا اغْفِرْ لَنَا ذُنُوبَنَا وَإِسْرَافَنَا فِي أَمْرِنَا وَثَبِّتْ أَقْدَامَنَا وَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ",
    transliteration: "Rabbana-ghfir lana dhunubana wa israfana fi amrina wa thabbit aqdamana wansurna 'alal-qawmil-kafirin",
    indonesian: "Ya Tuhan kami, ampunilah dosa-dosa kami dan tindakan-tindakan kami yang berlebihan dalam urusan kami, dan kukuhkanlah pendirian kami dan tolonglah kami terhadap orang-orang kafir.",
    english: "Our Lord, forgive us our sins and the excess [committed] in our affairs and plant our feet firmly and give us victory over the disbelieving people.",
    reference: "QS. Ali Imran: 147",
    repeat: 1,
  },
  {
    id: "quran-20",
    category: "quran-prophet",
    title: "Doa Kemuliaan - Syukur",
    titleEn: "Gratitude and Honor",
    arabic: "رَبِّ أَعُوذُ بِكَ أَنْ أَسْأَلَكَ مَا لَيْسَ لِي بِهِ عِلْمٌ وَإِلَّا تَغْفِرْ لِي وَتَرْحَمْنِي أَكُنْ مِنَ الْخَاسِرِينَ",
    transliteration: "Rabbi a'udzu bika an as'alaka ma laysa li bihi 'ilm, wa illa taghfir li wa tarhamni akun minal-khasirin",
    indonesian: "Ya Tuhanku, aku berlindung kepada-Mu dari memohon kepada-Mu sesuatu yang aku tidak mengetahui hakikatnya. Dan jika Engkau tidak mengampuni dan menyayangiku, niscaya aku termasuk orang-orang yang merugi.",
    english: "My Lord, I seek refuge in You from asking that of which I have no knowledge. And unless You forgive me and have mercy upon me, I will be among the losers.",
    reference: "QS. Hud: 47",
    repeat: 1,
  },

  // ==================== PREMIUM DUAS ====================

  // Sleep Category (Tidur) - Moved to Daily Category
  {
    id: "sleep-1",
    category: "daily",
    title: "Doa Sebelum Tidur",
    titleEn: "Before Sleeping",
    arabic: "بِاسْمِكَ اللَّهُمَّ أَحْيَا وَأَمُوتُ",
    transliteration: "Bismika Allahumma ahya wa amut",
    indonesian: "Dengan nama-Mu Ya Allah aku hidup dan dengan nama-Mu aku mati.",
    english: "In Your Name, O Allah, I live and die.",
    reference: "HR. Bukhari & Muslim",
    repeat: 1,
    premium: false,
  },
  {
    id: "sleep-2",
    category: "daily",
    title: "Doa Bangun Tidur",
    titleEn: "Waking Up",
    arabic: "الْحَمْدُ لِلَّهِ الَّذِي أَحْيَانَا بَعْدَ مَا أَمَاتَنَا وَإِلَيْهِ النُّشُورُ",
    transliteration: "Alhamdu lillahil-ladzi ahyaana ba'da maa amaatanaa wa ilaihin-nushuur",
    indonesian: "Segala puji bagi Allah yang menghidupkan kami setelah mematikan kami dan kepada-Nya kami akan dikembalikan.",
    english: "Praise is to Allah Who gives us life after He has caused us to die and to Him is the return.",
    reference: "HR. Bukhari",
    repeat: 1,
    premium: false,
  },
  {
    id: "sleep-3",
    category: "daily",
    title: "Doa Tidur - Membaca Ayat Kursi",
    titleEn: "Sleep - Ayat Kursi",
    arabic: "اللَّهُ لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ",
    transliteration: "Allahu la ilaha illa huwal hayyul qayyum, la ta'khudhuhu sinatun wa la nawm, lahuma fis-samawati wa ma fil-ard",
    indonesian: "Allah, tidak ada Tuhan selain Dia. Yang Maha Hidup, Yang Maha Mandiri, tidak mengantuk dan tidak tidur. Milik-Nya apa yang ada di langit dan di bumi.",
    english: "Allah, there is no god but He, the Ever Living, the Self-Subsisting. Slumber overtakes Him not, nor sleep. To Him belongs whatever is in the heavens and the earth.",
    reference: "QS. Al-Baqarah: 255",
    repeat: 1,
    premium: false,
  },

  // Travel Category (Bepergian) - PREMIUM
  {
    id: "travel-1",
    category: "travel",
    title: "Doa Bepergian - Naik Kendaraan",
    titleEn: "Travel - Boarding Vehicle",
    arabic: "سُبْحَانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ وَإِنَّا إِلَى رَبِّنَا لَمُنْقَلِبُونَ",
    transliteration: "Subhanalladzi sakhkhara lana hadza wa ma kunna lahu muqrinin wa inna ila rabbina lamunqalibun",
    indonesian: "Maha Suci Allah yang menundukkan untuk kami kendaraan ini. Padahal sebelumnya kami tidak mampu menguasainya. Dan kepada Tuhan kami kami akan kembali.",
    english: "Glory is to Him Who has subjected this to us, and we were not capable of it. And to our Lord we will surely return.",
    reference: "QS. Az-Zukhruf: 13-14",
    repeat: 1,
    premium: true,
  },
  {
    id: "travel-2",
    category: "travel",
    title: "Doa Bepergian - Memohon Kemudahan",
    titleEn: "Travel - Ease in Journey",
    arabic: "اللَّهُمَّ إِنَّا نَسْأَلُكَ فِي سَفَرِنَا هَذَا الْبِرَّ وَالتَّقْوَى وَمِنَ الْعَمَلِ مَا تَرْضَى",
    transliteration: "Allahumma inna nas'aluka fi safarina hadhal-birra wat-taqwa wa minal-'amali ma tardha",
    indonesian: "Ya Allah, sesungguhnya kami memohon kepada-Mu dalam perjalanan kami ini kebaikan dan takwa, serta amal yang Engkau ridai.",
    english: "O Allah, we ask You for righteousness and piety in this journey of ours, and deeds that please You.",
    reference: "HR. Muslim",
    repeat: 1,
    premium: true,
  },
  {
    id: "travel-3",
    category: "travel",
    title: "Doa Kedatangan di Tempat Tujuan",
    titleEn: "Arrival at Destination",
    arabic: "اللَّهُمَّ أَنْتَ الصَّاحِبُ فِي السَّفَرِ وَالْخَلِيفَةُ فِي الْأَهْلِ",
    transliteration: "Allahumma antas-shahibu fis-safari wal-khalifatu fil-ahli",
    indonesian: "Ya Allah, Engkau adalah teman dalam perjalanan dan pengganti dalam keluarga.",
    english: "O Allah, You are the companion on the journey and the successor in the family.",
    reference: "HR. Muslim",
    repeat: 1,
    premium: true,
  },
  {
    id: "travel-4",
    category: "travel",
    title: "Doa Naik Pesawat",
    titleEn: "Boarding Airplane",
    arabic: "اللَّهُمَّ يَسِّرْ لَنَا أَمْرَنَا وَارْحَمْنَا فِي طَيَرَانِنَا",
    transliteration: "Allahumma yassir lana amrana warhamna fi tayyirina",
    indonesian: "Ya Allah, mudahkanlah urusan kami dan sayangilah kami dalam penerbangan kami.",
    english: "O Allah, ease our affairs and have mercy on us in our flight.",
    reference: "Doa Harian",
    repeat: 1,
    premium: true,
  },

  // Sickness Category (Sakit) - PREMIUM
  {
    id: "sickness-1",
    category: "sickness",
    title: "Doa Sakit - Ruqyah",
    titleEn: "Sickness - Ruqyah",
    arabic: "أَسْأَلُ اللَّهَ الْعَظِيمَ رَبَّ الْعَرْشِ الْعَظِيمِ أَنْ يُشْفِيَكَ",
    transliteration: "As'alullahal-'azim rabbal-'arshil-'azim an yushfika",
    indonesian: "Aku memohon kepada Allah Yang Maha Agung, Tuhan Arsy yang agung, agar Engkau menyembuhkanmu.",
    english: "I ask Allah the Mighty, Lord of the Mighty Throne, to heal you.",
    reference: "HR. Abu Dawud & Tirmidzi",
    repeat: 7,
    premium: true,
  },
  {
    id: "sickness-2",
    category: "sickness",
    title: "Doa Ketika Mengunjungi Orang Sakit",
    titleEn: "Visiting the Sick",
    arabic: "لَا بَأْسَ طَهُورٌ إِنْ شَاءَ اللَّهُ",
    transliteration: "La ba'sa thahur insyaallah",
    indonesian: "Tidak mengapa, semoga ini menjadi pembersih jika Allah menghendaki.",
    english: "No harm, it will be a purification if Allah wills.",
    reference: "HR. Bukhari",
    repeat: 3,
    premium: true,
  },
  {
    id: "sickness-3",
    category: "sickness",
    title: "Doa Kesembuhan - Surah Al-Fatihah",
    titleEn: "Healing - Al-Fatihah",
    arabic: "بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ الرَّحْمَنِ الرَّحِيمِ مَالِكِ يَوْمِ الدِّينِ إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ",
    transliteration: "Bismillahir rahmanir rahim. Alhamdu lillahi rabbil 'alamin. Ar-rahmanir rahim. Maliki yaumid din. Iyyaka na'budu wa iyyaka nasta'in. Ihdinas siratal mustaqim, siratalledzina an'amta 'alayhim ghayril maghdubi 'alayhim wa lad-dallin",
    indonesian: "Dengan menyebut nama Allah Yang Maha Pemurah lagi Maha Penyayang. Segala puji bagi Allah, Tuhan semesta alam. Maha Pemurah lagi Maha Penyayang. Yang menguasai di Hari Pembalasan. Hanya Engkau yang kami sembah, dan hanya kepada Engkau kami meminta pertolongan. Tunjukilah kami jalan yang lurus, (yaitu) jalan orang-orang yang telah Engkau beri nikmat kepada mereka; bukan (jalan) mereka yang dimurkai dan bukan (pula jalan) mereka yang sesat.",
    english: "In the name of Allah, the Entirely Merciful, the Especially Merciful. All praise is due to Allah, Lord of the worlds. The Entirely Merciful, the Especially Merciful. Sovereign of the Day of Recompense. It is You we worship and You we ask for help. Guide us to the straight path - The path of those upon whom You have bestowed favor, not of those who have evoked [Your] anger or of those who are astray.",
    reference: "QS. Al-Fatihah: 1-7",
    repeat: 1,
    premium: true,
  },
  {
    id: "sickness-4",
    category: "sickness",
    title: "Doa Memohon Kesehatan",
    titleEn: "Praying for Health",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ فِي الدُّنْيَا وَالْآخِرَةِ",
    transliteration: "Allahumma inni as'alukal-'afwa wal-'afiyah fid-dunya wal-akhirah",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu keafiatan (kesehatan) dan kesejahteraan di dunia dan akhirat.",
    english: "O Allah, I ask You for pardon and well-being in this world and the Hereafter.",
    reference: "HR. Ibn Majah",
    repeat: 3,
    premium: true,
  },

  // Protection Category (Perlindungan) - PREMIUM
  {
    id: "protection-1",
    category: "protection",
    title: "Doa Perlindungan - Al-Mu'awwidzat",
    titleEn: "Protection - Al-Mu'awwidzat",
    arabic: "أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيمِ",
    transliteration: "A'udzu billahi minasy-syaitanir rajim",
    indonesian: "Aku berlindung kepada Allah dari godaan syaitan yang terkutuk.",
    english: "I seek refuge in Allah from the accursed Satan.",
    reference: "QS. An-Nahl: 98",
    repeat: 1,
    premium: true,
  },
  {
    id: "protection-2",
    category: "protection",
    title: "Doa Perlindungan dari Keburukan",
    titleEn: "Protection from Evil",
    arabic: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ عَذَابِ جَهَنَّمَ وَمِنْ عَذَابِ الْقَبْرِ وَمِنْ فِتْنَةِ الْمَحْيَا وَالْمَمَاتِ وَمِنْ فِتْنَةِ الْمَسِيحِ الدَّجَّالِ",
    transliteration: "Allahumma inni a'udzu bika min 'adhabi jahannama wa min 'adhabil qabri wa min fitnatil mahya wal mamati wa min fitnatil masihid dajjal",
    indonesian: "Ya Allah, sesungguhnya aku berlindung kepada-Mu dari siksa neraka jahanam, siksa kubur, fitnah kehidupan dan kematian, serta fitnah Dajjal.",
    english: "O Allah, I seek refuge in You from the punishment of Hellfire, the punishment of the grave, the trials of life and death, and the trials of the False Messiah.",
    reference: "HR. Muslim",
    repeat: 3,
    premium: true,
  },
  {
    id: "protection-3",
    category: "protection",
    title: "Doa Perlindungan Diri dan Keluarga",
    titleEn: "Protection for Self and Family",
    arabic: "رَبَّنَا هَبْ لَنَا مِنْ أَزْوَاجِنَا وَذُرِّيَّاتِنَا قُرَّةَ أَعْيُنٍ وَاجْعَلْنَا لِلْمُتَّقِينَ إِمَامًا",
    transliteration: "Rabbana hab lana min azwajina wa dhurriyyatina qurrata a'yunin waj'alna lil-muttaqina imama",
    indonesian: "Ya Tuhan kami, anugerahkanlah kepada kami istri-istri dan keturunan kami sebagai penyenang hati, dan jadikanlah kami imam bagi orang-orang yang bertakwa.",
    english: "Our Lord, grant us from among our wives and offspring comfort to our eyes and make us an example for the righteous.",
    reference: "QS. Al-Furqan: 74",
    repeat: 1,
    premium: true,
  },
  {
    id: "protection-4",
    category: "protection",
    title: "Doa Menjaga Pandangan",
    titleEn: "Guarding the Gaze",
    arabic: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْهُدَى وَالتُّقَى وَالْعَفَافَ وَالْغِنَى",
    transliteration: "Allahumma inni as'alukal-huda wat-taqa wal-'afafal-ghina",
    indonesian: "Ya Allah, sesungguhnya aku memohon kepada-Mu petunjuk, ketakwaan, menjaga harga diri, dan kekayaan.",
    english: "O Allah, I ask You for guidance, piety, chastity, and self-sufficiency.",
    reference: "HR. Muslim",
    repeat: 3,
    premium: true,
  },

  // Prophet's Duas (Doa Nabi) - PREMIUM
  {
    id: "prophet-1",
    category: "quran-prophet",
    title: "Doa Nabi Ibrahim - Kesuburan",
    titleEn: "Prophet Ibrahim - Fertility",
    arabic: "رَبِّ لَا تَذَرْنِي فَرْدًا وَأَنْتَ خَيْرُ الْوَارِثِينَ",
    transliteration: "Rabbi la tadharni fardan wa anta khairul-warithin",
    indonesian: "Ya Tuhanku, janganlah Engkau membiarkanku hidup sendirian dan Engkau adalah Pewaris yang terbaik.",
    english: "My Lord, do not leave me alone [with no heir], and You are the best of inheritors.",
    reference: "QS. Al-Anbiya: 89",
    repeat: 1,
    premium: true,
  },
  {
    id: "prophet-2",
    category: "quran-prophet",
    title: "Doa Nabi Musa - Ketenangan",
    titleEn: "Prophet Musa - Tranquility",
    arabic: "رَبِّ اشْرَحْ لِي صَدْرِي وَيَسِّرْ لِي أَمْرِي وَاحْلُلْ عُقْدَةً مِنْ لِسَانِي يَفْقَهُوا قَوْلِي",
    transliteration: "Rabbi ishrah li sadri wa yassir li amri wa hlul 'uqdatan min lisani yafqahu qauli",
    indonesian: "Ya Tuhanku, lapangkanlah untukku dadaku, mudahkanlah untukku urusanku, dan lepaskanlah kekakuan dari lideku agar mereka mengerti perkataanku.",
    english: "My Lord, expand for me my breast [with assurance] and ease for me my task and untie the knot from my tongue that they may understand my speech.",
    reference: "QS. Taha: 25-28",
    repeat: 1,
    premium: true,
  },
  {
    id: "prophet-3",
    category: "quran-prophet",
    title: "Doa Nabi Yunus - Kesulitan",
    titleEn: "Prophet Yunus - Difficulty",
    arabic: "لَا إِلَهَ إِلَّا أَنْتَ سُبْحَانَكَ إِنِّي كُنْتُ مِنَ الظَّالِمِينَ",
    transliteration: "La ilaha illa anta subhanaka inni kuntu minaz-zalimin",
    indonesian: "Tidak ada Tuhan selain Engkau. Maha Suci Engkau. Sesungguhnya aku termasuk orang-orang yang zalim.",
    english: "There is no deity except You; exalted are You. Indeed, I have been of the wrongdoers.",
    reference: "QS. Al-Anbiya: 87",
    repeat: 1,
    premium: true,
  },
  {
    id: "prophet-4",
    category: "quran-prophet",
    title: "Doa Nabi Ayub - Kesembuhan",
    titleEn: "Prophet Ayub - Healing",
    arabic: "أَنِّي مَسَّنِيَ الضُّرُّ وَأَنْتَ أَرْحَمُ الرَّاحِمِينَ",
    transliteration: "Inni massaniyad-durru wa anta arhamur-rahimin",
    indonesian: "Sesungguhnya aku telah ditimpa penyakit dan Engkau adalah Yang Maha Penyayang di antara para penyayang.",
    english: "Indeed, adversity has touched me, and You are the Most Merciful of the merciful.",
    reference: "QS. Al-Anbiya: 83",
    repeat: 1,
    premium: true,
  },
  {
    id: "prophet-5",
    category: "quran-prophet",
    title: "Doa Nabi Muhammad - Kebijaksanaan",
    titleEn: "Prophet Muhammad - Wisdom",
    arabic: "رَبِّ زِدْنِي عِلْمًا",
    transliteration: "Rabbi zidni 'ilma",
    indonesian: "Ya Tuhanku, tambahkanlah kepadaku ilmu.",
    english: "My Lord, increase me in knowledge.",
    reference: "QS. Taha: 114",
    repeat: 1,
    premium: true,
  },
  {
    id: "prophet-6",
    category: "quran-prophet",
    title: "Doa Nabi Sulaiman - Kekayaan",
    titleEn: "Prophet Sulaiman - Wealth",
    arabic: "رَبِّ اغْفِرْ لِي وَهَبْ لِي مُلْكًا لَا يَنْبَغِي لِأَحَدٍ مِنْ بَعْدِي",
    transliteration: "Rabbi-ghfir li wahab li mulkan la yambaghi li-ahadin min ba'di",
    indonesian: "Ya Tuhanku, ampunilah aku dan anugerahkanlah kepadaku kerajaan yang tidak dimiliki seorang pun setelahku.",
    english: "My Lord, forgive me and grant me a kingdom such as will not belong to anyone after me.",
    reference: "QS. Sad: 35",
    repeat: 1,
    premium: true,
  },
];

export const getDoasByCategory = (categoryId) => {
  if (categoryId === "all") return DUAS;
  return DUAS.filter(doa => doa.category === categoryId);
};

export const getDoaById = (doaId) => {
  return DUAS.find(doa => doa.id === doaId);
};

export default {
  DOA_CATEGORIES,
  DUAS,
  getDoasByCategory,
  getDoaById,
};
